// src/pages/ContentEditor/components/BasicInfoCard.js
import React, { useState, useEffect, useRef } from 'react';
import { 
  Grid, 
  Paper, 
  Typography, 
  TextField, 
  alpha,
  Autocomplete,
  Box,
  Button,
  CircularProgress
} from '@mui/material';
import { AutoAwesome as AutoAwesomeIcon } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

// This would come from your JSON file
// import thumbnailData from '../data/thumbnails.json';

const thumbnailData = [
  {
    "originalName": "building-worlds-with-words.png",
    "key": "building-worlds-with-words",
    "originalPath": "art-and-creativity/building-worlds-with-words.png",
    "transformedName": "building-worlds-with-words.png",
    "transformedPath": "art-and-creativity/building-worlds-with-words.png",
    "displayName": "Building Worlds With Words",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/art-and-creativity/building-worlds-with-words.png"
  }
,
  {
    "originalName": "canvas-of-dreams-salvador-dali.png",
    "key": "canvas-of-dreams-salvador-dali",
    "originalPath": "art-and-creativity/canvas-of-dreams-salvador-dali.png",
    "transformedName": "canvas-of-dreams-salvador-dali.png",
    "transformedPath": "art-and-creativity/canvas-of-dreams-salvador-dali.png",
    "displayName": "Canvas Of Dreams Salvador Dali",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/art-and-creativity/canvas-of-dreams-salvador-dali.png"
  }
,
  {
    "originalName": "capturing-life-in-photos.png",
    "key": "capturing-life-in-photos",
    "originalPath": "art-and-creativity/capturing-life-in-photos.png",
    "transformedName": "capturing-life-in-photos.png",
    "transformedPath": "art-and-creativity/capturing-life-in-photos.png",
    "displayName": "Capturing Life In Photos",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/art-and-creativity/capturing-life-in-photos.png"
  }
,
  {
    "originalName": "color-outside-the-lines.png",
    "key": "color-outside-the-lines",
    "originalPath": "art-and-creativity/color-outside-the-lines.png",
    "transformedName": "color-outside-the-lines.png",
    "transformedPath": "art-and-creativity/color-outside-the-lines.png",
    "displayName": "Color Outside The Lines",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/art-and-creativity/color-outside-the-lines.png"
  }
,
  {
    "originalName": "sculpting-dreams_-the-sotry-of-michelangelo.png",
    "key": "sculpting-dreams_-the-sotry-of-michelangelo",
    "originalPath": "art-and-creativity/sculpting-dreams_-the-sotry-of-michelangelo.png",
    "transformedName": "sculpting-dreams_-the-sotry-of-michelangelo.png",
    "transformedPath": "art-and-creativity/sculpting-dreams_-the-sotry-of-michelangelo.png",
    "displayName": "Sculpting Dreams_ The Sotry Of Michelangelo",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/art-and-creativity/sculpting-dreams_-the-sotry-of-michelangelo.png"
  }
,
  {
    "originalName": "symphony-of-colors_-monet.png",
    "key": "symphony-of-colors_-monet",
    "originalPath": "art-and-creativity/symphony-of-colors_-monet.png",
    "transformedName": "symphony-of-colors_-monet.png",
    "transformedPath": "art-and-creativity/symphony-of-colors_-monet.png",
    "displayName": "Symphony Of Colors_ Monet",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/art-and-creativity/symphony-of-colors_-monet.png"
  }
,
  {
    "originalName": "the-author-of-her-own-story.png",
    "key": "the-author-of-her-own-story",
    "originalPath": "art-and-creativity/the-author-of-her-own-story.png",
    "transformedName": "the-author-of-her-own-story.png",
    "transformedPath": "art-and-creativity/the-author-of-her-own-story.png",
    "displayName": "The Author Of Her Own Story",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/art-and-creativity/the-author-of-her-own-story.png"
  }
,
  {
    "originalName": "the-design-thinker.png",
    "key": "the-design-thinker",
    "originalPath": "art-and-creativity/the-design-thinker.png",
    "transformedName": "the-design-thinker.png",
    "transformedPath": "art-and-creativity/the-design-thinker.png",
    "displayName": "The Design Thinker",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/art-and-creativity/the-design-thinker.png"
  }
,
  {
    "originalName": "the-mural-on-maple-street.png",
    "key": "the-mural-on-maple-street",
    "originalPath": "art-and-creativity/the-mural-on-maple-street.png",
    "transformedName": "the-mural-on-maple-street.png",
    "transformedPath": "art-and-creativity/the-mural-on-maple-street.png",
    "displayName": "The Mural On Maple Street",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/art-and-creativity/the-mural-on-maple-street.png"
  }
,
  {
    "originalName": "the-muse_s-touch.png",
    "key": "the-muse_s-touch",
    "originalPath": "art-and-creativity/the-muse_s-touch.png",
    "transformedName": "the-muse_s-touch.png",
    "transformedPath": "art-and-creativity/the-muse_s-touch.png",
    "displayName": "The Muse_S Touch",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/art-and-creativity/the-muse_s-touch.png"
  }
,
  {
    "originalName": "entrepreneurial-journeys.png",
    "key": "entrepreneurial-journeys",
    "originalPath": "business-and-economics/entrepreneurial-journeys.png",
    "transformedName": "entrepreneurial-journeys.png",
    "transformedPath": "business-and-economics/entrepreneurial-journeys.png",
    "displayName": "Entrepreneurial Journeys",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/business-and-economics/entrepreneurial-journeys.png"
  }
,
  {
    "originalName": "from-lemonade-stand-to-empire.png",
    "key": "from-lemonade-stand-to-empire",
    "originalPath": "business-and-economics/from-lemonade-stand-to-empire.png",
    "transformedName": "from-lemonade-stand-to-empire.png",
    "transformedPath": "business-and-economics/from-lemonade-stand-to-empire.png",
    "displayName": "From Lemonade Stand To Empire",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/business-and-economics/from-lemonade-stand-to-empire.png"
  }
,
  {
    "originalName": "navigating-the-market-waves.png",
    "key": "navigating-the-market-waves",
    "originalPath": "business-and-economics/navigating-the-market-waves.png",
    "transformedName": "navigating-the-market-waves.png",
    "transformedPath": "business-and-economics/navigating-the-market-waves.png",
    "displayName": "Navigating The Market Waves",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/business-and-economics/navigating-the-market-waves.png"
  }
,
  {
    "originalName": "the-artist-with-a-business-plan.png",
    "key": "the-artist-with-a-business-plan",
    "originalPath": "business-and-economics/the-artist-with-a-business-plan.png",
    "transformedName": "the-artist-with-a-business-plan.png",
    "transformedPath": "business-and-economics/the-artist-with-a-business-plan.png",
    "displayName": "The Artist With A Business Plan",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/business-and-economics/the-artist-with-a-business-plan.png"
  }
,
  {
    "originalName": "the-economics-of-everyday-life.png",
    "key": "the-economics-of-everyday-life",
    "originalPath": "business-and-economics/the-economics-of-everyday-life.png",
    "transformedName": "the-economics-of-everyday-life.png",
    "transformedPath": "business-and-economics/the-economics-of-everyday-life.png",
    "displayName": "The Economics Of Everyday Life",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/business-and-economics/the-economics-of-everyday-life.png"
  }
,
  {
    "originalName": "the-fearless-founder.png",
    "key": "the-fearless-founder",
    "originalPath": "business-and-economics/the-fearless-founder.png",
    "transformedName": "the-fearless-founder.png",
    "transformedPath": "business-and-economics/the-fearless-founder.png",
    "displayName": "The Fearless Founder",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/business-and-economics/the-fearless-founder.png"
  }
,
  {
    "originalName": "the-startup-revolution.png",
    "key": "the-startup-revolution",
    "originalPath": "business-and-economics/the-startup-revolution.png",
    "transformedName": "the-startup-revolution.png",
    "transformedPath": "business-and-economics/the-startup-revolution.png",
    "displayName": "The Startup Revolution",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/business-and-economics/the-startup-revolution.png"
  }
,
  {
    "originalName": "the-young-entrepreneur_s-playbook-(1).png",
    "key": "the-young-entrepreneur_s-playbook-(1)",
    "originalPath": "business-and-economics/the-young-entrepreneur_s-playbook-(1).png",
    "transformedName": "the-young-entrepreneur_s-playbook-(1).png",
    "transformedPath": "business-and-economics/the-young-entrepreneur_s-playbook-(1).png",
    "displayName": "The Young Entrepreneur_S Playbook (1)",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/business-and-economics/the-young-entrepreneur_s-playbook-(1).png"
  }
,
  {
    "originalName": "code-breakers_-the-life-of-a-developer.png",
    "key": "code-breakers_-the-life-of-a-developer",
    "originalPath": "career-exploration/code-breakers_-the-life-of-a-developer.png",
    "transformedName": "code-breakers_-the-life-of-a-developer.png",
    "transformedPath": "career-exploration/code-breakers_-the-life-of-a-developer.png",
    "displayName": "Code Breakers_ The Life Of A Developer",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/career-exploration/code-breakers_-the-life-of-a-developer.png"
  }
,
  {
    "originalName": "creating-worlds_-the-life-of-an-architect.png",
    "key": "creating-worlds_-the-life-of-an-architect",
    "originalPath": "career-exploration/creating-worlds_-the-life-of-an-architect.png",
    "transformedName": "creating-worlds_-the-life-of-an-architect.png",
    "transformedPath": "career-exploration/creating-worlds_-the-life-of-an-architect.png",
    "displayName": "Creating Worlds_ The Life Of An Architect",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/career-exploration/creating-worlds_-the-life-of-an-architect.png"
  }
,
  {
    "originalName": "degree-of-discovery.png",
    "key": "degree-of-discovery",
    "originalPath": "career-exploration/degree-of-discovery.png",
    "transformedName": "degree-of-discovery.png",
    "transformedPath": "career-exploration/degree-of-discovery.png",
    "displayName": "Degree Of Discovery",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/career-exploration/degree-of-discovery.png"
  }
,
  {
    "originalName": "soaring-above-the-clouds_-a-pilot_s-journey.png",
    "key": "soaring-above-the-clouds_-a-pilot_s-journey",
    "originalPath": "career-exploration/soaring-above-the-clouds_-a-pilot_s-journey.png",
    "transformedName": "soaring-above-the-clouds_-a-pilot_s-journey.png",
    "transformedPath": "career-exploration/soaring-above-the-clouds_-a-pilot_s-journey.png",
    "displayName": "Soaring Above The Clouds_ A Pilot_S Journey",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/career-exploration/soaring-above-the-clouds_-a-pilot_s-journey.png"
  }
,
  {
    "originalName": "stage-lights-and-scripts.png",
    "key": "stage-lights-and-scripts",
    "originalPath": "career-exploration/stage-lights-and-scripts.png",
    "transformedName": "stage-lights-and-scripts.png",
    "transformedPath": "career-exploration/stage-lights-and-scripts.png",
    "displayName": "Stage Lights And Scripts",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/career-exploration/stage-lights-and-scripts.png"
  }
,
  {
    "originalName": "the-animal-healer.png",
    "key": "the-animal-healer",
    "originalPath": "career-exploration/the-animal-healer.png",
    "transformedName": "the-animal-healer.png",
    "transformedPath": "career-exploration/the-animal-healer.png",
    "displayName": "The Animal Healer",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/career-exploration/the-animal-healer.png"
  }
,
  {
    "originalName": "the-career-compass.png",
    "key": "the-career-compass",
    "originalPath": "career-exploration/the-career-compass.png",
    "transformedName": "the-career-compass.png",
    "transformedPath": "career-exploration/the-career-compass.png",
    "displayName": "The Career Compass",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/career-exploration/the-career-compass.png"
  }
,
  {
    "originalName": "the-choice-between-two-schools.png",
    "key": "the-choice-between-two-schools",
    "originalPath": "career-exploration/the-choice-between-two-schools.png",
    "transformedName": "the-choice-between-two-schools.png",
    "transformedPath": "career-exploration/the-choice-between-two-schools.png",
    "displayName": "The Choice Between Two Schools",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/career-exploration/the-choice-between-two-schools.png"
  }
,
  {
    "originalName": "the-heart-of-the-classroom.png",
    "key": "the-heart-of-the-classroom",
    "originalPath": "career-exploration/the-heart-of-the-classroom.png",
    "transformedName": "the-heart-of-the-classroom.png",
    "transformedPath": "career-exploration/the-heart-of-the-classroom.png",
    "displayName": "The Heart Of The Classroom",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/career-exploration/the-heart-of-the-classroom.png"
  }
,
  {
    "originalName": "the-path-of-a-park-ranger.png",
    "key": "the-path-of-a-park-ranger",
    "originalPath": "career-exploration/the-path-of-a-park-ranger.png",
    "transformedName": "the-path-of-a-park-ranger.png",
    "transformedPath": "career-exploration/the-path-of-a-park-ranger.png",
    "displayName": "The Path Of A Park Ranger",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/career-exploration/the-path-of-a-park-ranger.png"
  }
,
  {
    "originalName": "ventures-of-visionary.png",
    "key": "ventures-of-visionary",
    "originalPath": "career-exploration/ventures-of-visionary.png",
    "transformedName": "ventures-of-visionary.png",
    "transformedPath": "career-exploration/ventures-of-visionary.png",
    "displayName": "Ventures Of Visionary",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/career-exploration/ventures-of-visionary.png"
  }
,
  {
    "originalName": "beyond-the-classroom.png",
    "key": "beyond-the-classroom",
    "originalPath": "college-exploration/beyond-the-classroom.png",
    "transformedName": "beyond-the-classroom.png",
    "transformedPath": "college-exploration/beyond-the-classroom.png",
    "displayName": "Beyond The Classroom",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/college-exploration/beyond-the-classroom.png"
  }
,
  {
    "originalName": "campus-quest.png",
    "key": "campus-quest",
    "originalPath": "college-exploration/campus-quest.png",
    "transformedName": "campus-quest.png",
    "transformedPath": "college-exploration/campus-quest.png",
    "displayName": "Campus Quest",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/college-exploration/campus-quest.png"
  }
,
  {
    "originalName": "studying-across-the-seas.png",
    "key": "studying-across-the-seas",
    "originalPath": "college-exploration/studying-across-the-seas.png",
    "transformedName": "studying-across-the-seas.png",
    "transformedPath": "college-exploration/studying-across-the-seas.png",
    "displayName": "Studying Across The Seas",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/college-exploration/studying-across-the-seas.png"
  }
,
  {
    "originalName": "the-first-application.png",
    "key": "the-first-application",
    "originalPath": "college-exploration/the-first-application.png",
    "transformedName": "the-first-application.png",
    "transformedPath": "college-exploration/the-first-application.png",
    "displayName": "The First Application",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/college-exploration/the-first-application.png"
  }
,
  {
    "originalName": "the-major-i-never-considered.png",
    "key": "the-major-i-never-considered",
    "originalPath": "college-exploration/the-major-i-never-considered.png",
    "transformedName": "the-major-i-never-considered.png",
    "transformedPath": "college-exploration/the-major-i-never-considered.png",
    "displayName": "The Major I Never Considered",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/college-exploration/the-major-i-never-considered.png"
  }
,
  {
    "originalName": "the-orientation-adventure-(1).png",
    "key": "the-orientation-adventure-(1)",
    "originalPath": "college-exploration/the-orientation-adventure-(1).png",
    "transformedName": "the-orientation-adventure-(1).png",
    "transformedPath": "college-exploration/the-orientation-adventure-(1).png",
    "displayName": "The Orientation Adventure (1)",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/college-exploration/the-orientation-adventure-(1).png"
  }
,
  {
    "originalName": "celebrations-around-the-sun.png",
    "key": "celebrations-around-the-sun",
    "originalPath": "culture-and-traditions/celebrations-around-the-sun.png",
    "transformedName": "celebrations-around-the-sun.png",
    "transformedPath": "culture-and-traditions/celebrations-around-the-sun.png",
    "displayName": "Celebrations Around The Sun",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/culture-and-traditions/celebrations-around-the-sun.png"
  }
,
  {
    "originalName": "dance-of-the-lanterns.png",
    "key": "dance-of-the-lanterns",
    "originalPath": "culture-and-traditions/dance-of-the-lanterns.png",
    "transformedName": "dance-of-the-lanterns.png",
    "transformedPath": "culture-and-traditions/dance-of-the-lanterns.png",
    "displayName": "Dance Of The Lanterns",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/culture-and-traditions/dance-of-the-lanterns.png"
  }
,
  {
    "originalName": "dances-of-the-world.png",
    "key": "dances-of-the-world",
    "originalPath": "culture-and-traditions/dances-of-the-world.png",
    "transformedName": "dances-of-the-world.png",
    "transformedPath": "culture-and-traditions/dances-of-the-world.png",
    "displayName": "Dances Of The World",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/culture-and-traditions/dances-of-the-world.png"
  }
,
  {
    "originalName": "forgotten-queens-of-history.png",
    "key": "forgotten-queens-of-history",
    "originalPath": "culture-and-traditions/forgotten-queens-of-history.png",
    "transformedName": "forgotten-queens-of-history.png",
    "transformedPath": "culture-and-traditions/forgotten-queens-of-history.png",
    "displayName": "Forgotten Queens Of History",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/culture-and-traditions/forgotten-queens-of-history.png"
  }
,
  {
    "originalName": "painted-stories-on-clay-walls.png",
    "key": "painted-stories-on-clay-walls",
    "originalPath": "culture-and-traditions/painted-stories-on-clay-walls.png",
    "transformedName": "painted-stories-on-clay-walls.png",
    "transformedPath": "culture-and-traditions/painted-stories-on-clay-walls.png",
    "displayName": "Painted Stories On Clay Walls",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/culture-and-traditions/painted-stories-on-clay-walls.png"
  }
,
  {
    "originalName": "songs-of-the-southern-cross.png",
    "key": "songs-of-the-southern-cross",
    "originalPath": "culture-and-traditions/songs-of-the-southern-cross.png",
    "transformedName": "songs-of-the-southern-cross.png",
    "transformedPath": "culture-and-traditions/songs-of-the-southern-cross.png",
    "displayName": "Songs Of The Southern Cross",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/culture-and-traditions/songs-of-the-southern-cross.png"
  }
,
  {
    "originalName": "the-fabric-of-identity.png",
    "key": "the-fabric-of-identity",
    "originalPath": "culture-and-traditions/the-fabric-of-identity.png",
    "transformedName": "the-fabric-of-identity.png",
    "transformedPath": "culture-and-traditions/the-fabric-of-identity.png",
    "displayName": "The Fabric Of Identity",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/culture-and-traditions/the-fabric-of-identity.png"
  }
,
  {
    "originalName": "the-fesival-of-many-colors.png",
    "key": "the-fesival-of-many-colors",
    "originalPath": "culture-and-traditions/the-fesival-of-many-colors.png",
    "transformedName": "the-fesival-of-many-colors.png",
    "transformedPath": "culture-and-traditions/the-fesival-of-many-colors.png",
    "displayName": "The Fesival Of Many Colors",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/culture-and-traditions/the-fesival-of-many-colors.png"
  }
,
  {
    "originalName": "journey-to-eldoria.png",
    "key": "journey-to-eldoria",
    "originalPath": "fantasy-and-adventure/journey-to-eldoria.png",
    "transformedName": "journey-to-eldoria.png",
    "transformedPath": "fantasy-and-adventure/journey-to-eldoria.png",
    "displayName": "Journey To Eldoria",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/fantasy-and-adventure/journey-to-eldoria.png"
  }
,
  {
    "originalName": "path-of-the-moonstone-warrior.png",
    "key": "path-of-the-moonstone-warrior",
    "originalPath": "fantasy-and-adventure/path-of-the-moonstone-warrior.png",
    "transformedName": "path-of-the-moonstone-warrior.png",
    "transformedPath": "fantasy-and-adventure/path-of-the-moonstone-warrior.png",
    "displayName": "Path Of The Moonstone Warrior",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/fantasy-and-adventure/path-of-the-moonstone-warrior.png"
  }
,
  {
    "originalName": "secrets-of-the-skybound-isles.png",
    "key": "secrets-of-the-skybound-isles",
    "originalPath": "fantasy-and-adventure/secrets-of-the-skybound-isles.png",
    "transformedName": "secrets-of-the-skybound-isles.png",
    "transformedPath": "fantasy-and-adventure/secrets-of-the-skybound-isles.png",
    "displayName": "Secrets Of The Skybound Isles",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/fantasy-and-adventure/secrets-of-the-skybound-isles.png"
  }
,
  {
    "originalName": "the-dragon_s-call.png",
    "key": "the-dragon_s-call",
    "originalPath": "fantasy-and-adventure/the-dragon_s-call.png",
    "transformedName": "the-dragon_s-call.png",
    "transformedPath": "fantasy-and-adventure/the-dragon_s-call.png",
    "displayName": "The Dragon_S Call",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/fantasy-and-adventure/the-dragon_s-call.png"
  }
,
  {
    "originalName": "the-enchanted-realm.png",
    "key": "the-enchanted-realm",
    "originalPath": "fantasy-and-adventure/the-enchanted-realm.png",
    "transformedName": "the-enchanted-realm.png",
    "transformedPath": "fantasy-and-adventure/the-enchanted-realm.png",
    "displayName": "The Enchanted Realm",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/fantasy-and-adventure/the-enchanted-realm.png"
  }
,
  {
    "originalName": "the-lost-city-of-thalara.png",
    "key": "the-lost-city-of-thalara",
    "originalPath": "fantasy-and-adventure/the-lost-city-of-thalara.png",
    "transformedName": "the-lost-city-of-thalara.png",
    "transformedPath": "fantasy-and-adventure/the-lost-city-of-thalara.png",
    "displayName": "The Lost City Of Thalara",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/fantasy-and-adventure/the-lost-city-of-thalara.png"
  }
,
  {
    "originalName": "the-scroll-of-seven-moons.png",
    "key": "the-scroll-of-seven-moons",
    "originalPath": "fantasy-and-adventure/the-scroll-of-seven-moons.png",
    "transformedName": "the-scroll-of-seven-moons.png",
    "transformedPath": "fantasy-and-adventure/the-scroll-of-seven-moons.png",
    "displayName": "The Scroll Of Seven Moons",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/fantasy-and-adventure/the-scroll-of-seven-moons.png"
  }
,
  {
    "originalName": "wings-over-the-forgotten-realm.png",
    "key": "wings-over-the-forgotten-realm",
    "originalPath": "fantasy-and-adventure/wings-over-the-forgotten-realm.png",
    "transformedName": "wings-over-the-forgotten-realm.png",
    "transformedPath": "fantasy-and-adventure/wings-over-the-forgotten-realm.png",
    "displayName": "Wings Over The Forgotten Realm",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/fantasy-and-adventure/wings-over-the-forgotten-realm.png"
  }
,
  {
    "originalName": "cashflow-chronicles.png",
    "key": "cashflow-chronicles",
    "originalPath": "financial-literacy/cashflow-chronicles.png",
    "transformedName": "cashflow-chronicles.png",
    "transformedPath": "financial-literacy/cashflow-chronicles.png",
    "displayName": "Cashflow Chronicles",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/financial-literacy/cashflow-chronicles.png"
  }
,
  {
    "originalName": "from-zero-to-financial-hero.png",
    "key": "from-zero-to-financial-hero",
    "originalPath": "financial-literacy/from-zero-to-financial-hero.png",
    "transformedName": "from-zero-to-financial-hero.png",
    "transformedPath": "financial-literacy/from-zero-to-financial-hero.png",
    "displayName": "From Zero To Financial Hero",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/financial-literacy/from-zero-to-financial-hero.png"
  }
,
  {
    "originalName": "leo_s-journey-to-financial-wisdom.png",
    "key": "leo_s-journey-to-financial-wisdom",
    "originalPath": "financial-literacy/leo_s-journey-to-financial-wisdom.png",
    "transformedName": "leo_s-journey-to-financial-wisdom.png",
    "transformedPath": "financial-literacy/leo_s-journey-to-financial-wisdom.png",
    "displayName": "Leo_S Journey To Financial Wisdom",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/financial-literacy/leo_s-journey-to-financial-wisdom.png"
  }
,
  {
    "originalName": "money-mindset-magic.png",
    "key": "money-mindset-magic",
    "originalPath": "financial-literacy/money-mindset-magic.png",
    "transformedName": "money-mindset-magic.png",
    "transformedPath": "financial-literacy/money-mindset-magic.png",
    "displayName": "Money Mindset Magic",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/financial-literacy/money-mindset-magic.png"
  }
,
  {
    "originalName": "money-moves-for-teens.png",
    "key": "money-moves-for-teens",
    "originalPath": "financial-literacy/money-moves-for-teens.png",
    "transformedName": "money-moves-for-teens.png",
    "transformedPath": "financial-literacy/money-moves-for-teens.png",
    "displayName": "Money Moves For Teens",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/financial-literacy/money-moves-for-teens.png"
  }
,
  {
    "originalName": "the-basics-of-building-wealth.png",
    "key": "the-basics-of-building-wealth",
    "originalPath": "financial-literacy/the-basics-of-building-wealth.png",
    "transformedName": "the-basics-of-building-wealth.png",
    "transformedPath": "financial-literacy/the-basics-of-building-wealth.png",
    "displayName": "The Basics Of Building Wealth",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/financial-literacy/the-basics-of-building-wealth.png"
  }
,
  {
    "originalName": "the-road-to-financial-freedom.png",
    "key": "the-road-to-financial-freedom",
    "originalPath": "financial-literacy/the-road-to-financial-freedom.png",
    "transformedName": "the-road-to-financial-freedom.png",
    "transformedPath": "financial-literacy/the-road-to-financial-freedom.png",
    "displayName": "The Road To Financial Freedom",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/financial-literacy/the-road-to-financial-freedom.png"
  }
,
  {
    "originalName": "the-savings-race.png",
    "key": "the-savings-race",
    "originalPath": "financial-literacy/the-savings-race.png",
    "transformedName": "the-savings-race.png",
    "transformedPath": "financial-literacy/the-savings-race.png",
    "displayName": "The Savings Race",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/financial-literacy/the-savings-race.png"
  }
,
  {
    "originalName": "the-wealth-blueprint.png",
    "key": "the-wealth-blueprint",
    "originalPath": "financial-literacy/the-wealth-blueprint.png",
    "transformedName": "the-wealth-blueprint.png",
    "transformedPath": "financial-literacy/the-wealth-blueprint.png",
    "displayName": "The Wealth Blueprint",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/financial-literacy/the-wealth-blueprint.png"
  }
,
  {
    "originalName": "your-first-paycheck.png",
    "key": "your-first-paycheck",
    "originalPath": "financial-literacy/your-first-paycheck.png",
    "transformedName": "your-first-paycheck.png",
    "transformedPath": "financial-literacy/your-first-paycheck.png",
    "displayName": "Your First Paycheck",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/financial-literacy/your-first-paycheck.png"
  }
,
  {
    "originalName": "a-feast-for-the-senses.png",
    "key": "a-feast-for-the-senses",
    "originalPath": "food-and-culinary-arts/a-feast-for-the-senses.png",
    "transformedName": "a-feast-for-the-senses.png",
    "transformedPath": "food-and-culinary-arts/a-feast-for-the-senses.png",
    "displayName": "A Feast For The Senses",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/food-and-culinary-arts/a-feast-for-the-senses.png"
  }
,
  {
    "originalName": "baking-through-the-seasons.png",
    "key": "baking-through-the-seasons",
    "originalPath": "food-and-culinary-arts/baking-through-the-seasons.png",
    "transformedName": "baking-through-the-seasons.png",
    "transformedPath": "food-and-culinary-arts/baking-through-the-seasons.png",
    "displayName": "Baking Through The Seasons",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/food-and-culinary-arts/baking-through-the-seasons.png"
  }
,
  {
    "originalName": "battle-of-the-bakers.png",
    "key": "battle-of-the-bakers",
    "originalPath": "food-and-culinary-arts/battle-of-the-bakers.png",
    "transformedName": "battle-of-the-bakers.png",
    "transformedPath": "food-and-culinary-arts/battle-of-the-bakers.png",
    "displayName": "Battle Of The Bakers",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/food-and-culinary-arts/battle-of-the-bakers.png"
  }
,
  {
    "originalName": "culinary-travels_-pizza-and-pasta-from-italy.png",
    "key": "culinary-travels_-pizza-and-pasta-from-italy",
    "originalPath": "food-and-culinary-arts/culinary-travels_-pizza-and-pasta-from-italy.png",
    "transformedName": "culinary-travels_-pizza-and-pasta-from-italy.png",
    "transformedPath": "food-and-culinary-arts/culinary-travels_-pizza-and-pasta-from-italy.png",
    "displayName": "Culinary Travels_ Pizza And Pasta From Italy",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/food-and-culinary-arts/culinary-travels_-pizza-and-pasta-from-italy.png"
  }
,
  {
    "originalName": "kitchen-science.png",
    "key": "kitchen-science",
    "originalPath": "food-and-culinary-arts/kitchen-science.png",
    "transformedName": "kitchen-science.png",
    "transformedPath": "food-and-culinary-arts/kitchen-science.png",
    "displayName": "Kitchen Science",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/food-and-culinary-arts/kitchen-science.png"
  }
,
  {
    "originalName": "recipes-from-grandma’s-garden.png",
    "key": "recipes-from-grandma’s-garden",
    "originalPath": "food-and-culinary-arts/recipes-from-grandma’s-garden.png",
    "transformedName": "recipes-from-grandma’s-garden.png",
    "transformedPath": "food-and-culinary-arts/recipes-from-grandma’s-garden.png",
    "displayName": "Recipes From Grandma’s Garden",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/food-and-culinary-arts/recipes-from-grandma’s-garden.png"
  }
,
  {
    "originalName": "street-food-stories_-flavors-of-the-city.png",
    "key": "street-food-stories_-flavors-of-the-city",
    "originalPath": "food-and-culinary-arts/street-food-stories_-flavors-of-the-city.png",
    "transformedName": "street-food-stories_-flavors-of-the-city.png",
    "transformedPath": "food-and-culinary-arts/street-food-stories_-flavors-of-the-city.png",
    "displayName": "Street Food Stories_ Flavors Of The City",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/food-and-culinary-arts/street-food-stories_-flavors-of-the-city.png"
  }
,
  {
    "originalName": "the-flavor-chronicles.png",
    "key": "the-flavor-chronicles",
    "originalPath": "food-and-culinary-arts/the-flavor-chronicles.png",
    "transformedName": "the-flavor-chronicles.png",
    "transformedPath": "food-and-culinary-arts/the-flavor-chronicles.png",
    "displayName": "The Flavor Chronicles",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/food-and-culinary-arts/the-flavor-chronicles.png"
  }
,
  {
    "originalName": "the-food-truck-dream.png",
    "key": "the-food-truck-dream",
    "originalPath": "food-and-culinary-arts/the-food-truck-dream.png",
    "transformedName": "the-food-truck-dream.png",
    "transformedPath": "food-and-culinary-arts/the-food-truck-dream.png",
    "displayName": "The Food Truck Dream",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/food-and-culinary-arts/the-food-truck-dream.png"
  }
,
  {
    "originalName": "the-taste-test-challenge.png",
    "key": "the-taste-test-challenge",
    "originalPath": "food-and-culinary-arts/the-taste-test-challenge.png",
    "transformedName": "the-taste-test-challenge.png",
    "transformedPath": "food-and-culinary-arts/the-taste-test-challenge.png",
    "displayName": "The Taste Test Challenge",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/food-and-culinary-arts/the-taste-test-challenge.png"
  }
,
  {
    "originalName": "circles-of-trust.png",
    "key": "circles-of-trust",
    "originalPath": "friendship-and-community/circles-of-trust.png",
    "transformedName": "circles-of-trust.png",
    "transformedPath": "friendship-and-community/circles-of-trust.png",
    "displayName": "Circles Of Trust",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/friendship-and-community/circles-of-trust.png"
  }
,
  {
    "originalName": "creating-friendship-bonds.png",
    "key": "creating-friendship-bonds",
    "originalPath": "friendship-and-community/creating-friendship-bonds.png",
    "transformedName": "creating-friendship-bonds.png",
    "transformedPath": "friendship-and-community/creating-friendship-bonds.png",
    "displayName": "Creating Friendship Bonds",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/friendship-and-community/creating-friendship-bonds.png"
  }
,
  {
    "originalName": "home-is-where-we-gather.png",
    "key": "home-is-where-we-gather",
    "originalPath": "friendship-and-community/home-is-where-we-gather.png",
    "transformedName": "home-is-where-we-gather.png",
    "transformedPath": "friendship-and-community/home-is-where-we-gather.png",
    "displayName": "Home Is Where We Gather",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/friendship-and-community/home-is-where-we-gather.png"
  }
,
  {
    "originalName": "letters-between-friends.png",
    "key": "letters-between-friends",
    "originalPath": "friendship-and-community/letters-between-friends.png",
    "transformedName": "letters-between-friends.png",
    "transformedPath": "friendship-and-community/letters-between-friends.png",
    "displayName": "Letters Between Friends",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/friendship-and-community/letters-between-friends.png"
  }
,
  {
    "originalName": "summer-nights-and-street-fairs.png",
    "key": "summer-nights-and-street-fairs",
    "originalPath": "friendship-and-community/summer-nights-and-street-fairs.png",
    "transformedName": "summer-nights-and-street-fairs.png",
    "transformedPath": "friendship-and-community/summer-nights-and-street-fairs.png",
    "displayName": "Summer Nights And Street Fairs",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/friendship-and-community/summer-nights-and-street-fairs.png"
  }
,
  {
    "originalName": "the-block-party-pact.png",
    "key": "the-block-party-pact",
    "originalPath": "friendship-and-community/the-block-party-pact.png",
    "transformedName": "the-block-party-pact.png",
    "transformedPath": "friendship-and-community/the-block-party-pact.png",
    "displayName": "The Block Party Pact",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/friendship-and-community/the-block-party-pact.png"
  }
,
  {
    "originalName": "the-day-the-town-came-alive.png",
    "key": "the-day-the-town-came-alive",
    "originalPath": "friendship-and-community/the-day-the-town-came-alive.png",
    "transformedName": "the-day-the-town-came-alive.png",
    "transformedPath": "friendship-and-community/the-day-the-town-came-alive.png",
    "displayName": "The Day The Town Came Alive",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/friendship-and-community/the-day-the-town-came-alive.png"
  }
,
  {
    "originalName": "the-team-that-built-a-treehouse.png",
    "key": "the-team-that-built-a-treehouse",
    "originalPath": "friendship-and-community/the-team-that-built-a-treehouse.png",
    "transformedName": "the-team-that-built-a-treehouse.png",
    "transformedPath": "friendship-and-community/the-team-that-built-a-treehouse.png",
    "displayName": "The Team That Built A Treehouse",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/friendship-and-community/the-team-that-built-a-treehouse.png"
  }
,
  {
    "originalName": "the-village-heartbeat.png",
    "key": "the-village-heartbeat",
    "originalPath": "friendship-and-community/the-village-heartbeat.png",
    "transformedName": "the-village-heartbeat.png",
    "transformedPath": "friendship-and-community/the-village-heartbeat.png",
    "displayName": "The Village Heartbeat",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/friendship-and-community/the-village-heartbeat.png"
  }
,
  {
    "originalName": "the-village-that-raised-me.png",
    "key": "the-village-that-raised-me",
    "originalPath": "friendship-and-community/the-village-that-raised-me.png",
    "transformedName": "the-village-that-raised-me.png",
    "transformedPath": "friendship-and-community/the-village-that-raised-me.png",
    "displayName": "The Village That Raised Me",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/friendship-and-community/the-village-that-raised-me.png"
  }
,
  {
    "originalName": "citizens-of-sector-nine.png",
    "key": "citizens-of-sector-nine",
    "originalPath": "futuristic-and-dystopian/citizens-of-sector-nine.png",
    "transformedName": "citizens-of-sector-nine.png",
    "transformedPath": "futuristic-and-dystopian/citizens-of-sector-nine.png",
    "displayName": "Citizens Of Sector Nine",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/futuristic-and-dystopian/citizens-of-sector-nine.png"
  }
,
  {
    "originalName": "city-of-echoes.png",
    "key": "city-of-echoes",
    "originalPath": "futuristic-and-dystopian/city-of-echoes.png",
    "transformedName": "city-of-echoes.png",
    "transformedPath": "futuristic-and-dystopian/city-of-echoes.png",
    "displayName": "City Of Echoes",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/futuristic-and-dystopian/city-of-echoes.png"
  }
,
  {
    "originalName": "escape-from-the-iron-wasteland.png",
    "key": "escape-from-the-iron-wasteland",
    "originalPath": "futuristic-and-dystopian/escape-from-the-iron-wasteland.png",
    "transformedName": "escape-from-the-iron-wasteland.png",
    "transformedPath": "futuristic-and-dystopian/escape-from-the-iron-wasteland.png",
    "displayName": "Escape From The Iron Wasteland",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/futuristic-and-dystopian/escape-from-the-iron-wasteland.png"
  }
,
  {
    "originalName": "eyes-on-the-watchtower.png",
    "key": "eyes-on-the-watchtower",
    "originalPath": "futuristic-and-dystopian/eyes-on-the-watchtower.png",
    "transformedName": "eyes-on-the-watchtower.png",
    "transformedPath": "futuristic-and-dystopian/eyes-on-the-watchtower.png",
    "displayName": "Eyes On The Watchtower",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/futuristic-and-dystopian/eyes-on-the-watchtower.png"
  }
,
  {
    "originalName": "in-shadows-we-rise.png",
    "key": "in-shadows-we-rise",
    "originalPath": "futuristic-and-dystopian/in-shadows-we-rise.png",
    "transformedName": "in-shadows-we-rise.png",
    "transformedPath": "futuristic-and-dystopian/in-shadows-we-rise.png",
    "displayName": "In Shadows We Rise",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/futuristic-and-dystopian/in-shadows-we-rise.png"
  }
,
  {
    "originalName": "locked-out-of-eden.png",
    "key": "locked-out-of-eden",
    "originalPath": "futuristic-and-dystopian/locked-out-of-eden.png",
    "transformedName": "locked-out-of-eden.png",
    "transformedPath": "futuristic-and-dystopian/locked-out-of-eden.png",
    "displayName": "Locked Out Of Eden",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/futuristic-and-dystopian/locked-out-of-eden.png"
  }
,
  {
    "originalName": "outlaws-of-the-new-dawn.png",
    "key": "outlaws-of-the-new-dawn",
    "originalPath": "futuristic-and-dystopian/outlaws-of-the-new-dawn.png",
    "transformedName": "outlaws-of-the-new-dawn.png",
    "transformedPath": "futuristic-and-dystopian/outlaws-of-the-new-dawn.png",
    "displayName": "Outlaws Of The New Dawn",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/futuristic-and-dystopian/outlaws-of-the-new-dawn.png"
  }
,
  {
    "originalName": "the-last-city-standing.png",
    "key": "the-last-city-standing",
    "originalPath": "futuristic-and-dystopian/the-last-city-standing.png",
    "transformedName": "the-last-city-standing.png",
    "transformedPath": "futuristic-and-dystopian/the-last-city-standing.png",
    "displayName": "The Last City Standing",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/futuristic-and-dystopian/the-last-city-standing.png"
  }
,
  {
    "originalName": "the-last-utopia.png",
    "key": "the-last-utopia",
    "originalPath": "futuristic-and-dystopian/the-last-utopia.png",
    "transformedName": "the-last-utopia.png",
    "transformedPath": "futuristic-and-dystopian/the-last-utopia.png",
    "displayName": "The Last Utopia",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/futuristic-and-dystopian/the-last-utopia.png"
  }
,
  {
    "originalName": "the-new-dawn-rebellion.png",
    "key": "the-new-dawn-rebellion",
    "originalPath": "futuristic-and-dystopian/the-new-dawn-rebellion.png",
    "transformedName": "the-new-dawn-rebellion.png",
    "transformedPath": "futuristic-and-dystopian/the-new-dawn-rebellion.png",
    "displayName": "The New Dawn Rebellion",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/futuristic-and-dystopian/the-new-dawn-rebellion.png"
  }
,
  {
    "originalName": "auggie_s-mission-to-meteor-valley.png",
    "key": "auggie_s-mission-to-meteor-valley",
    "originalPath": "glyph-space-explorer/auggie_s-mission-to-meteor-valley.png",
    "transformedName": "auggie_s-mission-to-meteor-valley.png",
    "transformedPath": "glyph-space-explorer/auggie_s-mission-to-meteor-valley.png",
    "displayName": "Auggie_S Mission To Meteor Valley",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/glyph-space-explorer/auggie_s-mission-to-meteor-valley.png"
  }
,
  {
    "originalName": "avira_s-hidden-planet.png",
    "key": "avira_s-hidden-planet",
    "originalPath": "glyph-space-explorer/avira_s-hidden-planet.png",
    "transformedName": "avira_s-hidden-planet.png",
    "transformedPath": "glyph-space-explorer/avira_s-hidden-planet.png",
    "displayName": "Avira_S Hidden Planet",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/glyph-space-explorer/avira_s-hidden-planet.png"
  }
,
  {
    "originalName": "avira’s-mission-to-moon-base-9.png",
    "key": "avira’s-mission-to-moon-base-9",
    "originalPath": "glyph-space-explorer/avira’s-mission-to-moon-base-9.png",
    "transformedName": "avira’s-mission-to-moon-base-9.png",
    "transformedPath": "glyph-space-explorer/avira’s-mission-to-moon-base-9.png",
    "displayName": "Avira’s Mission To Moon Base 9",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/glyph-space-explorer/avira’s-mission-to-moon-base-9.png"
  }
,
  {
    "originalName": "grough’s-unexpected-space-detour.png",
    "key": "grough’s-unexpected-space-detour",
    "originalPath": "glyph-space-explorer/grough’s-unexpected-space-detour.png",
    "transformedName": "grough’s-unexpected-space-detour.png",
    "transformedPath": "glyph-space-explorer/grough’s-unexpected-space-detour.png",
    "displayName": "Grough’s Unexpected Space Detour",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/glyph-space-explorer/grough’s-unexpected-space-detour.png"
  }
,
  {
    "originalName": "kermix-and-the-lost-star-map.png",
    "key": "kermix-and-the-lost-star-map",
    "originalPath": "glyph-space-explorer/kermix-and-the-lost-star-map.png",
    "transformedName": "kermix-and-the-lost-star-map.png",
    "transformedPath": "glyph-space-explorer/kermix-and-the-lost-star-map.png",
    "displayName": "Kermix And The Lost Star Map",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/glyph-space-explorer/kermix-and-the-lost-star-map.png"
  }
,
  {
    "originalName": "koda_s-new-space-racer.png",
    "key": "koda_s-new-space-racer",
    "originalPath": "glyph-space-explorer/koda_s-new-space-racer.png",
    "transformedName": "koda_s-new-space-racer.png",
    "transformedPath": "glyph-space-explorer/koda_s-new-space-racer.png",
    "displayName": "Koda_S New Space Racer",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/glyph-space-explorer/koda_s-new-space-racer.png"
  }
,
  {
    "originalName": "koda-and-the-glyph-gate-challenge.png",
    "key": "koda-and-the-glyph-gate-challenge",
    "originalPath": "glyph-space-explorer/koda-and-the-glyph-gate-challenge.png",
    "transformedName": "koda-and-the-glyph-gate-challenge.png",
    "transformedPath": "glyph-space-explorer/koda-and-the-glyph-gate-challenge.png",
    "displayName": "Koda And The Glyph Gate Challenge",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/glyph-space-explorer/koda-and-the-glyph-gate-challenge.png"
  }
,
  {
    "originalName": "luska-uncovers-the-glyph-thief.png",
    "key": "luska-uncovers-the-glyph-thief",
    "originalPath": "glyph-space-explorer/luska-uncovers-the-glyph-thief.png",
    "transformedName": "luska-uncovers-the-glyph-thief.png",
    "transformedPath": "glyph-space-explorer/luska-uncovers-the-glyph-thief.png",
    "displayName": "Luska Uncovers The Glyph Thief",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/glyph-space-explorer/luska-uncovers-the-glyph-thief.png"
  }
,
  {
    "originalName": "lyris-and-auggie-build-the-star-bridge.png",
    "key": "lyris-and-auggie-build-the-star-bridge",
    "originalPath": "glyph-space-explorer/lyris-and-auggie-build-the-star-bridge.png",
    "transformedName": "lyris-and-auggie-build-the-star-bridge.png",
    "transformedPath": "glyph-space-explorer/lyris-and-auggie-build-the-star-bridge.png",
    "displayName": "Lyris And Auggie Build The Star Bridge",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/glyph-space-explorer/lyris-and-auggie-build-the-star-bridge.png"
  }
,
  {
    "originalName": "lyris-finds-the-missing-stargate.png",
    "key": "lyris-finds-the-missing-stargate",
    "originalPath": "glyph-space-explorer/lyris-finds-the-missing-stargate.png",
    "transformedName": "lyris-finds-the-missing-stargate.png",
    "transformedPath": "glyph-space-explorer/lyris-finds-the-missing-stargate.png",
    "displayName": "Lyris Finds The Missing Stargate",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/glyph-space-explorer/lyris-finds-the-missing-stargate.png"
  }
,
  {
    "originalName": "symia-and-luska’s-solar-quest.png",
    "key": "symia-and-luska’s-solar-quest",
    "originalPath": "glyph-space-explorer/symia-and-luska’s-solar-quest.png",
    "transformedName": "symia-and-luska’s-solar-quest.png",
    "transformedPath": "glyph-space-explorer/symia-and-luska’s-solar-quest.png",
    "displayName": "Symia And Luska’s Solar Quest",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/glyph-space-explorer/symia-and-luska’s-solar-quest.png"
  }
,
  {
    "originalName": "symia’s-asteroid-adventure.png",
    "key": "symia’s-asteroid-adventure",
    "originalPath": "glyph-space-explorer/symia’s-asteroid-adventure.png",
    "transformedName": "symia’s-asteroid-adventure.png",
    "transformedPath": "glyph-space-explorer/symia’s-asteroid-adventure.png",
    "displayName": "Symia’s Asteroid Adventure",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/glyph-space-explorer/symia’s-asteroid-adventure.png"
  }
,
  {
    "originalName": "symia’s-secret-moon-garden.png",
    "key": "symia’s-secret-moon-garden",
    "originalPath": "glyph-space-explorer/symia’s-secret-moon-garden.png",
    "transformedName": "symia’s-secret-moon-garden.png",
    "transformedPath": "glyph-space-explorer/symia’s-secret-moon-garden.png",
    "displayName": "Symia’s Secret Moon Garden",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/glyph-space-explorer/symia’s-secret-moon-garden.png"
  }
,
  {
    "originalName": "zebo-vs.-the-time-loop-tunnel.png",
    "key": "zebo-vs.-the-time-loop-tunnel",
    "originalPath": "glyph-space-explorer/zebo-vs.-the-time-loop-tunnel.png",
    "transformedName": "zebo-vs.-the-time-loop-tunnel.png",
    "transformedPath": "glyph-space-explorer/zebo-vs.-the-time-loop-tunnel.png",
    "displayName": "Zebo Vs. The Time Loop Tunnel",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/glyph-space-explorer/zebo-vs.-the-time-loop-tunnel.png"
  }
,
  {
    "originalName": "zebo’s-clue-from-the-cosmic-archives.png",
    "key": "zebo’s-clue-from-the-cosmic-archives",
    "originalPath": "glyph-space-explorer/zebo’s-clue-from-the-cosmic-archives.png",
    "transformedName": "zebo’s-clue-from-the-cosmic-archives.png",
    "transformedPath": "glyph-space-explorer/zebo’s-clue-from-the-cosmic-archives.png",
    "displayName": "Zebo’s Clue From The Cosmic Archives",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/glyph-space-explorer/zebo’s-clue-from-the-cosmic-archives.png"
  }
,
  {
    "originalName": "brain-waves-and-big-ideas.png",
    "key": "brain-waves-and-big-ideas",
    "originalPath": "health-and-human-sciences/brain-waves-and-big-ideas.png",
    "transformedName": "brain-waves-and-big-ideas.png",
    "transformedPath": "health-and-human-sciences/brain-waves-and-big-ideas.png",
    "displayName": "Brain Waves And Big Ideas",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/health-and-human-sciences/brain-waves-and-big-ideas.png"
  }
,
  {
    "originalName": "breaking-a-sweat.png",
    "key": "breaking-a-sweat",
    "originalPath": "health-and-human-sciences/breaking-a-sweat.png",
    "transformedName": "breaking-a-sweat.png",
    "transformedPath": "health-and-human-sciences/breaking-a-sweat.png",
    "displayName": "Breaking A Sweat",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/health-and-human-sciences/breaking-a-sweat.png"
  }
,
  {
    "originalName": "emotional-intelligence_-the-superpower-within.png",
    "key": "emotional-intelligence_-the-superpower-within",
    "originalPath": "health-and-human-sciences/emotional-intelligence_-the-superpower-within.png",
    "transformedName": "emotional-intelligence_-the-superpower-within.png",
    "transformedPath": "health-and-human-sciences/emotional-intelligence_-the-superpower-within.png",
    "displayName": "Emotional Intelligence_ The Superpower Within",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/health-and-human-sciences/emotional-intelligence_-the-superpower-within.png"
  }
,
  {
    "originalName": "fueling-your-body,-powering-your-life.png",
    "key": "fueling-your-body,-powering-your-life",
    "originalPath": "health-and-human-sciences/fueling-your-body,-powering-your-life.png",
    "transformedName": "fueling-your-body,-powering-your-life.png",
    "transformedPath": "health-and-human-sciences/fueling-your-body,-powering-your-life.png",
    "displayName": "Fueling Your Body, Powering Your Life",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/health-and-human-sciences/fueling-your-body,-powering-your-life.png"
  }
,
  {
    "originalName": "journey-through-the-human-body.png",
    "key": "journey-through-the-human-body",
    "originalPath": "health-and-human-sciences/journey-through-the-human-body.png",
    "transformedName": "journey-through-the-human-body.png",
    "transformedPath": "health-and-human-sciences/journey-through-the-human-body.png",
    "displayName": "Journey Through The Human Body",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/health-and-human-sciences/journey-through-the-human-body.png"
  }
,
  {
    "originalName": "nutrition-decoded.png",
    "key": "nutrition-decoded",
    "originalPath": "health-and-human-sciences/nutrition-decoded.png",
    "transformedName": "nutrition-decoded.png",
    "transformedPath": "health-and-human-sciences/nutrition-decoded.png",
    "displayName": "Nutrition Decoded",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/health-and-human-sciences/nutrition-decoded.png"
  }
,
  {
    "originalName": "the-human-genome_-unlocking-life_s-blueprint.png",
    "key": "the-human-genome_-unlocking-life_s-blueprint",
    "originalPath": "health-and-human-sciences/the-human-genome_-unlocking-life_s-blueprint.png",
    "transformedName": "the-human-genome_-unlocking-life_s-blueprint.png",
    "transformedPath": "health-and-human-sciences/the-human-genome_-unlocking-life_s-blueprint.png",
    "displayName": "The Human Genome_ Unlocking Life_S Blueprint",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/health-and-human-sciences/the-human-genome_-unlocking-life_s-blueprint.png"
  }
,
  {
    "originalName": "the-mind-body-connection.png",
    "key": "the-mind-body-connection",
    "originalPath": "health-and-human-sciences/the-mind-body-connection.png",
    "transformedName": "the-mind-body-connection.png",
    "transformedPath": "health-and-human-sciences/the-mind-body-connection.png",
    "displayName": "The Mind Body Connection",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/health-and-human-sciences/the-mind-body-connection.png"
  }
,
  {
    "originalName": "the-science-of-eating-well.png",
    "key": "the-science-of-eating-well",
    "originalPath": "health-and-human-sciences/the-science-of-eating-well.png",
    "transformedName": "the-science-of-eating-well.png",
    "transformedPath": "health-and-human-sciences/the-science-of-eating-well.png",
    "displayName": "The Science Of Eating Well",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/health-and-human-sciences/the-science-of-eating-well.png"
  }
,
  {
    "originalName": "unlocking-the-secrets-of-the-brain.png",
    "key": "unlocking-the-secrets-of-the-brain",
    "originalPath": "health-and-human-sciences/unlocking-the-secrets-of-the-brain.png",
    "transformedName": "unlocking-the-secrets-of-the-brain.png",
    "transformedPath": "health-and-human-sciences/unlocking-the-secrets-of-the-brain.png",
    "displayName": "Unlocking The Secrets Of The Brain",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/health-and-human-sciences/unlocking-the-secrets-of-the-brain.png"
  }
,
  {
    "originalName": "adventures-on-the-oregon-trail.png",
    "key": "adventures-on-the-oregon-trail",
    "originalPath": "history-and-heritage/adventures-on-the-oregon-trail.png",
    "transformedName": "adventures-on-the-oregon-trail.png",
    "transformedPath": "history-and-heritage/adventures-on-the-oregon-trail.png",
    "displayName": "Adventures On The Oregon Trail",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/history-and-heritage/adventures-on-the-oregon-trail.png"
  }
,
  {
    "originalName": "echoes-of-rome.png",
    "key": "echoes-of-rome",
    "originalPath": "history-and-heritage/echoes-of-rome.png",
    "transformedName": "echoes-of-rome.png",
    "transformedPath": "history-and-heritage/echoes-of-rome.png",
    "displayName": "Echoes Of Rome",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/history-and-heritage/echoes-of-rome.png"
  }
,
  {
    "originalName": "guardians-of-the-parthenon.png",
    "key": "guardians-of-the-parthenon",
    "originalPath": "history-and-heritage/guardians-of-the-parthenon.png",
    "transformedName": "guardians-of-the-parthenon.png",
    "transformedPath": "history-and-heritage/guardians-of-the-parthenon.png",
    "displayName": "Guardians Of The Parthenon",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/history-and-heritage/guardians-of-the-parthenon.png"
  }
,
  {
    "originalName": "journey-through-petra’s-lost-city.png",
    "key": "journey-through-petra’s-lost-city",
    "originalPath": "history-and-heritage/journey-through-petra’s-lost-city.png",
    "transformedName": "journey-through-petra’s-lost-city.png",
    "transformedPath": "history-and-heritage/journey-through-petra’s-lost-city.png",
    "displayName": "Journey Through Petra’s Lost City",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/history-and-heritage/journey-through-petra’s-lost-city.png"
  }
,
  {
    "originalName": "legends-of-angkor-wat.png",
    "key": "legends-of-angkor-wat",
    "originalPath": "history-and-heritage/legends-of-angkor-wat.png",
    "transformedName": "legends-of-angkor-wat.png",
    "transformedPath": "history-and-heritage/legends-of-angkor-wat.png",
    "displayName": "Legends Of Angkor Wat",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/history-and-heritage/legends-of-angkor-wat.png"
  }
,
  {
    "originalName": "secrets-of-ancient-egypt.png",
    "key": "secrets-of-ancient-egypt",
    "originalPath": "history-and-heritage/secrets-of-ancient-egypt.png",
    "transformedName": "secrets-of-ancient-egypt.png",
    "transformedPath": "history-and-heritage/secrets-of-ancient-egypt.png",
    "displayName": "Secrets Of Ancient Egypt",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/history-and-heritage/secrets-of-ancient-egypt.png"
  }
,
  {
    "originalName": "tales-from-the-underground-railroad.png",
    "key": "tales-from-the-underground-railroad",
    "originalPath": "history-and-heritage/tales-from-the-underground-railroad.png",
    "transformedName": "tales-from-the-underground-railroad.png",
    "transformedPath": "history-and-heritage/tales-from-the-underground-railroad.png",
    "displayName": "Tales From The Underground Railroad",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/history-and-heritage/tales-from-the-underground-railroad.png"
  }
,
  {
    "originalName": "the-code-of-the-samurai.png",
    "key": "the-code-of-the-samurai",
    "originalPath": "history-and-heritage/the-code-of-the-samurai.png",
    "transformedName": "the-code-of-the-samurai.png",
    "transformedPath": "history-and-heritage/the-code-of-the-samurai.png",
    "displayName": "The Code Of The Samurai",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/history-and-heritage/the-code-of-the-samurai.png"
  }
,
  {
    "originalName": "the-legacy-of-lady-liberty.png",
    "key": "the-legacy-of-lady-liberty",
    "originalPath": "history-and-heritage/the-legacy-of-lady-liberty.png",
    "transformedName": "the-legacy-of-lady-liberty.png",
    "transformedPath": "history-and-heritage/the-legacy-of-lady-liberty.png",
    "displayName": "The Legacy Of Lady Liberty",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/history-and-heritage/the-legacy-of-lady-liberty.png"
  }
,
  {
    "originalName": "beyond-the-horizon.png",
    "key": "beyond-the-horizon",
    "originalPath": "inspirational-and-motivational/beyond-the-horizon.png",
    "transformedName": "beyond-the-horizon.png",
    "transformedPath": "inspirational-and-motivational/beyond-the-horizon.png",
    "displayName": "Beyond The Horizon",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/inspirational-and-motivational/beyond-the-horizon.png"
  }
,
  {
    "originalName": "dreams-built-from-doubt.png",
    "key": "dreams-built-from-doubt",
    "originalPath": "inspirational-and-motivational/dreams-built-from-doubt.png",
    "transformedName": "dreams-built-from-doubt.png",
    "transformedPath": "inspirational-and-motivational/dreams-built-from-doubt.png",
    "displayName": "Dreams Built From Doubt",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/inspirational-and-motivational/dreams-built-from-doubt.png"
  }
,
  {
    "originalName": "joy-in-the-journey.png",
    "key": "joy-in-the-journey",
    "originalPath": "inspirational-and-motivational/joy-in-the-journey.png",
    "transformedName": "joy-in-the-journey.png",
    "transformedPath": "inspirational-and-motivational/joy-in-the-journey.png",
    "displayName": "Joy In The Journey",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/inspirational-and-motivational/joy-in-the-journey.png"
  }
,
  {
    "originalName": "rise-and-inspire.png",
    "key": "rise-and-inspire",
    "originalPath": "inspirational-and-motivational/rise-and-inspire.png",
    "transformedName": "rise-and-inspire.png",
    "transformedPath": "inspirational-and-motivational/rise-and-inspire.png",
    "displayName": "Rise And Inspire",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/inspirational-and-motivational/rise-and-inspire.png"
  }
,
  {
    "originalName": "the-climb-within.png",
    "key": "the-climb-within",
    "originalPath": "inspirational-and-motivational/the-climb-within.png",
    "transformedName": "the-climb-within.png",
    "transformedPath": "inspirational-and-motivational/the-climb-within.png",
    "displayName": "The Climb Within",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/inspirational-and-motivational/the-climb-within.png"
  }
,
  {
    "originalName": "the-light-we-carry.png",
    "key": "the-light-we-carry",
    "originalPath": "inspirational-and-motivational/the-light-we-carry.png",
    "transformedName": "the-light-we-carry.png",
    "transformedPath": "inspirational-and-motivational/the-light-we-carry.png",
    "displayName": "The Light We Carry",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/inspirational-and-motivational/the-light-we-carry.png"
  }
,
  {
    "originalName": "the-power-within.png",
    "key": "the-power-within",
    "originalPath": "inspirational-and-motivational/the-power-within.png",
    "transformedName": "the-power-within.png",
    "transformedPath": "inspirational-and-motivational/the-power-within.png",
    "displayName": "The Power Within",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/inspirational-and-motivational/the-power-within.png"
  }
,
  {
    "originalName": "financial-foundations_-building-blocks-to-independence.png",
    "key": "financial-foundations_-building-blocks-to-independence",
    "originalPath": "life-skills/financial-foundations_-building-blocks-to-independence.png",
    "transformedName": "financial-foundations_-building-blocks-to-independence.png",
    "transformedPath": "life-skills/financial-foundations_-building-blocks-to-independence.png",
    "displayName": "Financial Foundations_ Building Blocks To Independence",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/life-skills/financial-foundations_-building-blocks-to-independence.png"
  }
,
  {
    "originalName": "mastering-the-art-of-communication.png",
    "key": "mastering-the-art-of-communication",
    "originalPath": "life-skills/mastering-the-art-of-communication.png",
    "transformedName": "mastering-the-art-of-communication.png",
    "transformedPath": "life-skills/mastering-the-art-of-communication.png",
    "displayName": "Mastering The Art Of Communication",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/life-skills/mastering-the-art-of-communication.png"
  }
,
  {
    "originalName": "navigating-conversations-with-confidence.png",
    "key": "navigating-conversations-with-confidence",
    "originalPath": "life-skills/navigating-conversations-with-confidence.png",
    "transformedName": "navigating-conversations-with-confidence.png",
    "transformedPath": "life-skills/navigating-conversations-with-confidence.png",
    "displayName": "Navigating Conversations With Confidence",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/life-skills/navigating-conversations-with-confidence.png"
  }
,
  {
    "originalName": "skills-for-success.png",
    "key": "skills-for-success",
    "originalPath": "life-skills/skills-for-success.png",
    "transformedName": "skills-for-success.png",
    "transformedPath": "life-skills/skills-for-success.png",
    "displayName": "Skills For Success",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/life-skills/skills-for-success.png"
  }
,
  {
    "originalName": "the-art-of-adaptability-(1).png",
    "key": "the-art-of-adaptability-(1)",
    "originalPath": "life-skills/the-art-of-adaptability-(1).png",
    "transformedName": "the-art-of-adaptability-(1).png",
    "transformedPath": "life-skills/the-art-of-adaptability-(1).png",
    "displayName": "The Art Of Adaptability (1)",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/life-skills/the-art-of-adaptability-(1).png"
  }
,
  {
    "originalName": "the-art-pf-time-management-mastering-your-day.png",
    "key": "the-art-pf-time-management-mastering-your-day",
    "originalPath": "life-skills/the-art-pf-time-management-mastering-your-day.png",
    "transformedName": "the-art-pf-time-management-mastering-your-day.png",
    "transformedPath": "life-skills/the-art-pf-time-management-mastering-your-day.png",
    "displayName": "The Art Pf Time Management Mastering Your Day",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/life-skills/the-art-pf-time-management-mastering-your-day.png"
  }
,
  {
    "originalName": "the-organizer’s-blueprint.png",
    "key": "the-organizer’s-blueprint",
    "originalPath": "life-skills/the-organizer’s-blueprint.png",
    "transformedName": "the-organizer’s-blueprint.png",
    "transformedPath": "life-skills/the-organizer’s-blueprint.png",
    "displayName": "The Organizer’s Blueprint",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/life-skills/the-organizer’s-blueprint.png"
  }
,
  {
    "originalName": "the-visionary-leader.png",
    "key": "the-visionary-leader",
    "originalPath": "life-skills/the-visionary-leader.png",
    "transformedName": "the-visionary-leader.png",
    "transformedPath": "life-skills/the-visionary-leader.png",
    "displayName": "The Visionary Leader",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/life-skills/the-visionary-leader.png"
  }
,
  {
    "originalName": "braving-the-storm.png",
    "key": "braving-the-storm",
    "originalPath": "mindfulness-and-well-being/braving-the-storm.png",
    "transformedName": "braving-the-storm.png",
    "transformedPath": "mindfulness-and-well-being/braving-the-storm.png",
    "displayName": "Braving The Storm",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/mindfulness-and-well-being/braving-the-storm.png"
  }
,
  {
    "originalName": "finding-calm-in-chaos.png",
    "key": "finding-calm-in-chaos",
    "originalPath": "mindfulness-and-well-being/finding-calm-in-chaos.png",
    "transformedName": "finding-calm-in-chaos.png",
    "transformedPath": "mindfulness-and-well-being/finding-calm-in-chaos.png",
    "displayName": "Finding Calm In Chaos",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/mindfulness-and-well-being/finding-calm-in-chaos.png"
  }
,
  {
    "originalName": "listening-to-the-silence.png",
    "key": "listening-to-the-silence",
    "originalPath": "mindfulness-and-well-being/listening-to-the-silence.png",
    "transformedName": "listening-to-the-silence.png",
    "transformedPath": "mindfulness-and-well-being/listening-to-the-silence.png",
    "displayName": "Listening To The Silence",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/mindfulness-and-well-being/listening-to-the-silence.png"
  }
,
  {
    "originalName": "mindful-warriors.png",
    "key": "mindful-warriors",
    "originalPath": "mindfulness-and-well-being/mindful-warriors.png",
    "transformedName": "mindful-warriors.png",
    "transformedPath": "mindfulness-and-well-being/mindful-warriors.png",
    "displayName": "Mindful Warriors",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/mindfulness-and-well-being/mindful-warriors.png"
  }
,
  {
    "originalName": "rooted-in-calm.png",
    "key": "rooted-in-calm",
    "originalPath": "mindfulness-and-well-being/rooted-in-calm.png",
    "transformedName": "rooted-in-calm.png",
    "transformedPath": "mindfulness-and-well-being/rooted-in-calm.png",
    "displayName": "Rooted In Calm",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/mindfulness-and-well-being/rooted-in-calm.png"
  }
,
  {
    "originalName": "strength-in-every-breath.png",
    "key": "strength-in-every-breath",
    "originalPath": "mindfulness-and-well-being/strength-in-every-breath.png",
    "transformedName": "strength-in-every-breath.png",
    "transformedPath": "mindfulness-and-well-being/strength-in-every-breath.png",
    "displayName": "Strength In Every Breath",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/mindfulness-and-well-being/strength-in-every-breath.png"
  }
,
  {
    "originalName": "the-art-of-inner-peace.png",
    "key": "the-art-of-inner-peace",
    "originalPath": "mindfulness-and-well-being/the-art-of-inner-peace.png",
    "transformedName": "the-art-of-inner-peace.png",
    "transformedPath": "mindfulness-and-well-being/the-art-of-inner-peace.png",
    "displayName": "The Art Of Inner Peace",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/mindfulness-and-well-being/the-art-of-inner-peace.png"
  }
,
  {
    "originalName": "the-mindful-warriors-of-zenwood.png",
    "key": "the-mindful-warriors-of-zenwood",
    "originalPath": "mindfulness-and-well-being/the-mindful-warriors-of-zenwood.png",
    "transformedName": "the-mindful-warriors-of-zenwood.png",
    "transformedPath": "mindfulness-and-well-being/the-mindful-warriors-of-zenwood.png",
    "displayName": "The Mindful Warriors Of Zenwood",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/mindfulness-and-well-being/the-mindful-warriors-of-zenwood.png"
  }
,
  {
    "originalName": "the-stillness-garden.png",
    "key": "the-stillness-garden",
    "originalPath": "mindfulness-and-well-being/the-stillness-garden.png",
    "transformedName": "the-stillness-garden.png",
    "transformedPath": "mindfulness-and-well-being/the-stillness-garden.png",
    "displayName": "The Stillness Garden",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/mindfulness-and-well-being/the-stillness-garden.png"
  }
,
  {
    "originalName": "the-strength-of-a-quiet-mind.png",
    "key": "the-strength-of-a-quiet-mind",
    "originalPath": "mindfulness-and-well-being/the-strength-of-a-quiet-mind.png",
    "transformedName": "the-strength-of-a-quiet-mind.png",
    "transformedPath": "mindfulness-and-well-being/the-strength-of-a-quiet-mind.png",
    "displayName": "The Strength Of A Quiet Mind",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/mindfulness-and-well-being/the-strength-of-a-quiet-mind.png"
  }
,
  {
    "originalName": "bringing-characters-to-life_-the-magic-of-animation.png",
    "key": "bringing-characters-to-life_-the-magic-of-animation",
    "originalPath": "music-and-entertainment/bringing-characters-to-life_-the-magic-of-animation.png",
    "transformedName": "bringing-characters-to-life_-the-magic-of-animation.png",
    "transformedPath": "music-and-entertainment/bringing-characters-to-life_-the-magic-of-animation.png",
    "displayName": "Bringing Characters To Life_ The Magic Of Animation",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/music-and-entertainment/bringing-characters-to-life_-the-magic-of-animation.png"
  }
,
  {
    "originalName": "building-legends-in-minecraft.png",
    "key": "building-legends-in-minecraft",
    "originalPath": "music-and-entertainment/building-legends-in-minecraft.png",
    "transformedName": "building-legends-in-minecraft.png",
    "transformedPath": "music-and-entertainment/building-legends-in-minecraft.png",
    "displayName": "Building Legends In Minecraft",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/music-and-entertainment/building-legends-in-minecraft.png"
  }
,
  {
    "originalName": "dancing-to-my-own-beat.png",
    "key": "dancing-to-my-own-beat",
    "originalPath": "music-and-entertainment/dancing-to-my-own-beat.png",
    "transformedName": "dancing-to-my-own-beat.png",
    "transformedPath": "music-and-entertainment/dancing-to-my-own-beat.png",
    "displayName": "Dancing To My Own Beat",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/music-and-entertainment/dancing-to-my-own-beat.png"
  }
,
  {
    "originalName": "on-air_-the-world-behind-the-microphone.png",
    "key": "on-air_-the-world-behind-the-microphone",
    "originalPath": "music-and-entertainment/on-air_-the-world-behind-the-microphone.png",
    "transformedName": "on-air_-the-world-behind-the-microphone.png",
    "transformedPath": "music-and-entertainment/on-air_-the-world-behind-the-microphone.png",
    "displayName": "On Air_ The World Behind The Microphone",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/music-and-entertainment/on-air_-the-world-behind-the-microphone.png"
  }
,
  {
    "originalName": "rhymes-and-rhythms_-the-evolution-of-rap.png",
    "key": "rhymes-and-rhythms_-the-evolution-of-rap",
    "originalPath": "music-and-entertainment/rhymes-and-rhythms_-the-evolution-of-rap.png",
    "transformedName": "rhymes-and-rhythms_-the-evolution-of-rap.png",
    "transformedPath": "music-and-entertainment/rhymes-and-rhythms_-the-evolution-of-rap.png",
    "displayName": "Rhymes And Rhythms_ The Evolution Of Rap",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/music-and-entertainment/rhymes-and-rhythms_-the-evolution-of-rap.png"
  }
,
  {
    "originalName": "the-dj-diaries.png",
    "key": "the-dj-diaries",
    "originalPath": "music-and-entertainment/the-dj-diaries.png",
    "transformedName": "the-dj-diaries.png",
    "transformedPath": "music-and-entertainment/the-dj-diaries.png",
    "displayName": "The Dj Diaries",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/music-and-entertainment/the-dj-diaries.png"
  }
,
  {
    "originalName": "the-thrill-of-competing-in-fortnite.png",
    "key": "the-thrill-of-competing-in-fortnite",
    "originalPath": "music-and-entertainment/the-thrill-of-competing-in-fortnite.png",
    "transformedName": "the-thrill-of-competing-in-fortnite.png",
    "transformedPath": "music-and-entertainment/the-thrill-of-competing-in-fortnite.png",
    "displayName": "The Thrill Of Competing In Fortnite",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/music-and-entertainment/the-thrill-of-competing-in-fortnite.png"
  }
,
  {
    "originalName": "through-the-director’s-lens.png",
    "key": "through-the-director’s-lens",
    "originalPath": "music-and-entertainment/through-the-director’s-lens.png",
    "transformedName": "through-the-director’s-lens.png",
    "transformedPath": "music-and-entertainment/through-the-director’s-lens.png",
    "displayName": "Through The Director’s Lens",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/music-and-entertainment/through-the-director’s-lens.png"
  }
,
  {
    "originalName": "where-the-beat-begins.png",
    "key": "where-the-beat-begins",
    "originalPath": "music-and-entertainment/where-the-beat-begins.png",
    "transformedName": "where-the-beat-begins.png",
    "transformedPath": "music-and-entertainment/where-the-beat-begins.png",
    "displayName": "Where The Beat Begins",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/music-and-entertainment/where-the-beat-begins.png"
  }
,
  {
    "originalName": "wicked-harmonies.png",
    "key": "wicked-harmonies",
    "originalPath": "music-and-entertainment/wicked-harmonies.png",
    "transformedName": "wicked-harmonies.png",
    "transformedPath": "music-and-entertainment/wicked-harmonies.png",
    "displayName": "Wicked Harmonies",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/music-and-entertainment/wicked-harmonies.png"
  }
,
  {
    "originalName": "beneath-the-library-floor.png",
    "key": "beneath-the-library-floor",
    "originalPath": "mystery-and-thriller/beneath-the-library-floor.png",
    "transformedName": "beneath-the-library-floor.png",
    "transformedPath": "mystery-and-thriller/beneath-the-library-floor.png",
    "displayName": "Beneath The Library Floor",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/mystery-and-thriller/beneath-the-library-floor.png"
  }
,
  {
    "originalName": "beneath-the-surface.png",
    "key": "beneath-the-surface",
    "originalPath": "mystery-and-thriller/beneath-the-surface.png",
    "transformedName": "beneath-the-surface.png",
    "transformedPath": "mystery-and-thriller/beneath-the-surface.png",
    "displayName": "Beneath The Surface",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/mystery-and-thriller/beneath-the-surface.png"
  }
,
  {
    "originalName": "map-of-the-lost-tunnels.png",
    "key": "map-of-the-lost-tunnels",
    "originalPath": "mystery-and-thriller/map-of-the-lost-tunnels.png",
    "transformedName": "map-of-the-lost-tunnels.png",
    "transformedPath": "mystery-and-thriller/map-of-the-lost-tunnels.png",
    "displayName": "Map Of The Lost Tunnels",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/mystery-and-thriller/map-of-the-lost-tunnels.png"
  }
,
  {
    "originalName": "nightfall-in-the-redwood-realm.png",
    "key": "nightfall-in-the-redwood-realm",
    "originalPath": "mystery-and-thriller/nightfall-in-the-redwood-realm.png",
    "transformedName": "nightfall-in-the-redwood-realm.png",
    "transformedPath": "mystery-and-thriller/nightfall-in-the-redwood-realm.png",
    "displayName": "Nightfall In The Redwood Realm",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/mystery-and-thriller/nightfall-in-the-redwood-realm.png"
  }
,
  {
    "originalName": "secrets-from-lockwood-manor.png",
    "key": "secrets-from-lockwood-manor",
    "originalPath": "mystery-and-thriller/secrets-from-lockwood-manor.png",
    "transformedName": "secrets-from-lockwood-manor.png",
    "transformedPath": "mystery-and-thriller/secrets-from-lockwood-manor.png",
    "displayName": "Secrets From Lockwood Manor",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/mystery-and-thriller/secrets-from-lockwood-manor.png"
  }
,
  {
    "originalName": "the-phantom-of-willow-hall.png",
    "key": "the-phantom-of-willow-hall",
    "originalPath": "mystery-and-thriller/the-phantom-of-willow-hall.png",
    "transformedName": "the-phantom-of-willow-hall.png",
    "transformedPath": "mystery-and-thriller/the-phantom-of-willow-hall.png",
    "displayName": "The Phantom Of Willow Hall",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/mystery-and-thriller/the-phantom-of-willow-hall.png"
  }
,
  {
    "originalName": "the-puzzle-of-hollow-creek.png",
    "key": "the-puzzle-of-hollow-creek",
    "originalPath": "mystery-and-thriller/the-puzzle-of-hollow-creek.png",
    "transformedName": "the-puzzle-of-hollow-creek.png",
    "transformedPath": "mystery-and-thriller/the-puzzle-of-hollow-creek.png",
    "displayName": "The Puzzle Of Hollow Creek",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/mystery-and-thriller/the-puzzle-of-hollow-creek.png"
  }
,
  {
    "originalName": "the-vanishing-act.png",
    "key": "the-vanishing-act",
    "originalPath": "mystery-and-thriller/the-vanishing-act.png",
    "transformedName": "the-vanishing-act.png",
    "transformedPath": "mystery-and-thriller/the-vanishing-act.png",
    "displayName": "The Vanishing Act",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/mystery-and-thriller/the-vanishing-act.png"
  }
,
  {
    "originalName": "whispers-in-the-dark.png",
    "key": "whispers-in-the-dark",
    "originalPath": "mystery-and-thriller/whispers-in-the-dark.png",
    "transformedName": "whispers-in-the-dark.png",
    "transformedPath": "mystery-and-thriller/whispers-in-the-dark.png",
    "displayName": "Whispers In The Dark",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/mystery-and-thriller/whispers-in-the-dark.png"
  }
,
  {
    "originalName": "beneath-the-banyan-tree-(8).png",
    "key": "beneath-the-banyan-tree-(8)",
    "originalPath": "nature-and-environment/beneath-the-banyan-tree-(8).png",
    "transformedName": "beneath-the-banyan-tree-(8).png",
    "transformedPath": "nature-and-environment/beneath-the-banyan-tree-(8).png",
    "displayName": "Beneath The Banyan Tree (8)",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/nature-and-environment/beneath-the-banyan-tree-(8).png"
  }
,
  {
    "originalName": "beyond-the-stars.png",
    "key": "beyond-the-stars",
    "originalPath": "nature-and-environment/beyond-the-stars.png",
    "transformedName": "beyond-the-stars.png",
    "transformedPath": "nature-and-environment/beyond-the-stars.png",
    "displayName": "Beyond The Stars",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/nature-and-environment/beyond-the-stars.png"
  }
,
  {
    "originalName": "blueprints-of-the-future.png",
    "key": "blueprints-of-the-future",
    "originalPath": "nature-and-environment/blueprints-of-the-future.png",
    "transformedName": "blueprints-of-the-future.png",
    "transformedPath": "nature-and-environment/blueprints-of-the-future.png",
    "displayName": "Blueprints Of The Future",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/nature-and-environment/blueprints-of-the-future.png"
  }
,
  {
    "originalName": "chasing-the-northern-lights.png",
    "key": "chasing-the-northern-lights",
    "originalPath": "nature-and-environment/chasing-the-northern-lights.png",
    "transformedName": "chasing-the-northern-lights.png",
    "transformedPath": "nature-and-environment/chasing-the-northern-lights.png",
    "displayName": "Chasing The Northern Lights",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/nature-and-environment/chasing-the-northern-lights.png"
  }
,
  {
    "originalName": "echoes-of-the-ocean.png",
    "key": "echoes-of-the-ocean",
    "originalPath": "nature-and-environment/echoes-of-the-ocean.png",
    "transformedName": "echoes-of-the-ocean.png",
    "transformedPath": "nature-and-environment/echoes-of-the-ocean.png",
    "displayName": "Echoes Of The Ocean",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/nature-and-environment/echoes-of-the-ocean.png"
  }
,
  {
    "originalName": "guardians-of-the-wild.png",
    "key": "guardians-of-the-wild",
    "originalPath": "nature-and-environment/guardians-of-the-wild.png",
    "transformedName": "guardians-of-the-wild.png",
    "transformedPath": "nature-and-environment/guardians-of-the-wild.png",
    "displayName": "Guardians Of The Wild",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/nature-and-environment/guardians-of-the-wild.png"
  }
,
  {
    "originalName": "seeds-of-change.png",
    "key": "seeds-of-change",
    "originalPath": "nature-and-environment/seeds-of-change.png",
    "transformedName": "seeds-of-change.png",
    "transformedPath": "nature-and-environment/seeds-of-change.png",
    "displayName": "Seeds Of Change",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/nature-and-environment/seeds-of-change.png"
  }
,
  {
    "originalName": "sparks-from-the-sunflower-field.png",
    "key": "sparks-from-the-sunflower-field",
    "originalPath": "nature-and-environment/sparks-from-the-sunflower-field.png",
    "transformedName": "sparks-from-the-sunflower-field.png",
    "transformedPath": "nature-and-environment/sparks-from-the-sunflower-field.png",
    "displayName": "Sparks From The Sunflower Field",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/nature-and-environment/sparks-from-the-sunflower-field.png"
  }
,
  {
    "originalName": "the-earth-beneath-our-feet.png",
    "key": "the-earth-beneath-our-feet",
    "originalPath": "nature-and-environment/the-earth-beneath-our-feet.png",
    "transformedName": "the-earth-beneath-our-feet.png",
    "transformedPath": "nature-and-environment/the-earth-beneath-our-feet.png",
    "displayName": "The Earth Beneath Our Feet",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/nature-and-environment/the-earth-beneath-our-feet.png"
  }
,
  {
    "originalName": "the-forest’s-secret-language.png",
    "key": "the-forest’s-secret-language",
    "originalPath": "nature-and-environment/the-forest’s-secret-language.png",
    "transformedName": "the-forest’s-secret-language.png",
    "transformedPath": "nature-and-environment/the-forest’s-secret-language.png",
    "displayName": "The Forest’s Secret Language",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/nature-and-environment/the-forest’s-secret-language.png"
  }
,
  {
    "originalName": "the-last-rainforest.png",
    "key": "the-last-rainforest",
    "originalPath": "nature-and-environment/the-last-rainforest.png",
    "transformedName": "the-last-rainforest.png",
    "transformedPath": "nature-and-environment/the-last-rainforest.png",
    "displayName": "The Last Rainforest",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/nature-and-environment/the-last-rainforest.png"
  }
,
  {
    "originalName": "the-pollination-path.png",
    "key": "the-pollination-path",
    "originalPath": "nature-and-environment/the-pollination-path.png",
    "transformedName": "the-pollination-path.png",
    "transformedPath": "nature-and-environment/the-pollination-path.png",
    "displayName": "The Pollination Path",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/nature-and-environment/the-pollination-path.png"
  }
,
  {
    "originalName": "the-science-behind-the-magic.png",
    "key": "the-science-behind-the-magic",
    "originalPath": "nature-and-environment/the-science-behind-the-magic.png",
    "transformedName": "the-science-behind-the-magic.png",
    "transformedPath": "nature-and-environment/the-science-behind-the-magic.png",
    "displayName": "The Science Behind The Magic",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/nature-and-environment/the-science-behind-the-magic.png"
  }
,
  {
    "originalName": "the-wind-and-the-willow’s-song.png",
    "key": "the-wind-and-the-willow’s-song",
    "originalPath": "nature-and-environment/the-wind-and-the-willow’s-song.png",
    "transformedName": "the-wind-and-the-willow’s-song.png",
    "transformedPath": "nature-and-environment/the-wind-and-the-willow’s-song.png",
    "displayName": "The Wind And The Willow’s Song",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/nature-and-environment/the-wind-and-the-willow’s-song.png"
  }
,
  {
    "originalName": "underwater-adventures-with-luna-the-dolphin.png",
    "key": "underwater-adventures-with-luna-the-dolphin",
    "originalPath": "nature-and-environment/underwater-adventures-with-luna-the-dolphin.png",
    "transformedName": "underwater-adventures-with-luna-the-dolphin.png",
    "transformedPath": "nature-and-environment/underwater-adventures-with-luna-the-dolphin.png",
    "displayName": "Underwater Adventures With Luna The Dolphin",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/nature-and-environment/underwater-adventures-with-luna-the-dolphin.png"
  }
,
  {
    "originalName": "when-the-last-leaf-falls.png",
    "key": "when-the-last-leaf-falls",
    "originalPath": "nature-and-environment/when-the-last-leaf-falls.png",
    "transformedName": "when-the-last-leaf-falls.png",
    "transformedPath": "nature-and-environment/when-the-last-leaf-falls.png",
    "displayName": "When The Last Leaf Falls",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/nature-and-environment/when-the-last-leaf-falls.png"
  }
,
  {
    "originalName": "adventures-of-starlight-explorers.png",
    "key": "adventures-of-starlight-explorers",
    "originalPath": "science-and-technology/adventures-of-starlight-explorers.png",
    "transformedName": "adventures-of-starlight-explorers.png",
    "transformedPath": "science-and-technology/adventures-of-starlight-explorers.png",
    "displayName": "Adventures Of Starlight Explorers",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/science-and-technology/adventures-of-starlight-explorers.png"
  }
,
  {
    "originalName": "discovering-wonders-in-biotechnology.png",
    "key": "discovering-wonders-in-biotechnology",
    "originalPath": "science-and-technology/discovering-wonders-in-biotechnology.png",
    "transformedName": "discovering-wonders-in-biotechnology.png",
    "transformedPath": "science-and-technology/discovering-wonders-in-biotechnology.png",
    "displayName": "Discovering Wonders In Biotechnology",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/science-and-technology/discovering-wonders-in-biotechnology.png"
  }
,
  {
    "originalName": "inside-the-atom.png",
    "key": "inside-the-atom",
    "originalPath": "science-and-technology/inside-the-atom.png",
    "transformedName": "inside-the-atom.png",
    "transformedPath": "science-and-technology/inside-the-atom.png",
    "displayName": "Inside The Atom",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/science-and-technology/inside-the-atom.png"
  }
,
  {
    "originalName": "quantum-dreams-(1).png",
    "key": "quantum-dreams-(1)",
    "originalPath": "science-and-technology/quantum-dreams-(1).png",
    "transformedName": "quantum-dreams-(1).png",
    "transformedPath": "science-and-technology/quantum-dreams-(1).png",
    "displayName": "Quantum Dreams (1)",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/science-and-technology/quantum-dreams-(1).png"
  }
,
  {
    "originalName": "the-ai-paradox.png",
    "key": "the-ai-paradox",
    "originalPath": "science-and-technology/the-ai-paradox.png",
    "transformedName": "the-ai-paradox.png",
    "transformedPath": "science-and-technology/the-ai-paradox.png",
    "displayName": "The Ai Paradox",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/science-and-technology/the-ai-paradox.png"
  }
,
  {
    "originalName": "the-data-detective.png",
    "key": "the-data-detective",
    "originalPath": "science-and-technology/the-data-detective.png",
    "transformedName": "the-data-detective.png",
    "transformedPath": "science-and-technology/the-data-detective.png",
    "displayName": "The Data Detective",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/science-and-technology/the-data-detective.png"
  }
,
  {
    "originalName": "the-digital-dreamer-(3).png",
    "key": "the-digital-dreamer-(3)",
    "originalPath": "science-and-technology/the-digital-dreamer-(3).png",
    "transformedName": "the-digital-dreamer-(3).png",
    "transformedPath": "science-and-technology/the-digital-dreamer-(3).png",
    "displayName": "The Digital Dreamer (3)",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/science-and-technology/the-digital-dreamer-(3).png"
  }
,
  {
    "originalName": "the-gravity-experiment.png",
    "key": "the-gravity-experiment",
    "originalPath": "science-and-technology/the-gravity-experiment.png",
    "transformedName": "the-gravity-experiment.png",
    "transformedPath": "science-and-technology/the-gravity-experiment.png",
    "displayName": "The Gravity Experiment",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/science-and-technology/the-gravity-experiment.png"
  }
,
  {
    "originalName": "the-rocket-builders_-to-the-edge-of-orbit.png",
    "key": "the-rocket-builders_-to-the-edge-of-orbit",
    "originalPath": "science-and-technology/the-rocket-builders_-to-the-edge-of-orbit.png",
    "transformedName": "the-rocket-builders_-to-the-edge-of-orbit.png",
    "transformedPath": "science-and-technology/the-rocket-builders_-to-the-edge-of-orbit.png",
    "displayName": "The Rocket Builders_ To The Edge Of Orbit",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/science-and-technology/the-rocket-builders_-to-the-edge-of-orbit.png"
  }
,
  {
    "originalName": "champions-of-the-court.png",
    "key": "champions-of-the-court",
    "originalPath": "sports-and-recreation/champions-of-the-court.png",
    "transformedName": "champions-of-the-court.png",
    "transformedPath": "sports-and-recreation/champions-of-the-court.png",
    "displayName": "Champions Of The Court",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/sports-and-recreation/champions-of-the-court.png"
  }
,
  {
    "originalName": "rising-frim-the-ashes-a-football-story.png",
    "key": "rising-frim-the-ashes-a-football-story",
    "originalPath": "sports-and-recreation/rising-frim-the-ashes-a-football-story.png",
    "transformedName": "rising-frim-the-ashes-a-football-story.png",
    "transformedPath": "sports-and-recreation/rising-frim-the-ashes-a-football-story.png",
    "displayName": "Rising Frim The Ashes A Football Story",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/sports-and-recreation/rising-frim-the-ashes-a-football-story.png"
  }
,
  {
    "originalName": "the-final-sprint.png",
    "key": "the-final-sprint",
    "originalPath": "sports-and-recreation/the-final-sprint.png",
    "transformedName": "the-final-sprint.png",
    "transformedPath": "sports-and-recreation/the-final-sprint.png",
    "displayName": "The Final Sprint",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/sports-and-recreation/the-final-sprint.png"
  }
,
  {
    "originalName": "the-paddle-master.png",
    "key": "the-paddle-master",
    "originalPath": "sports-and-recreation/the-paddle-master.png",
    "transformedName": "the-paddle-master.png",
    "transformedPath": "sports-and-recreation/the-paddle-master.png",
    "displayName": "The Paddle Master",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/sports-and-recreation/the-paddle-master.png"
  }
,
  {
    "originalName": "the-precision-and-power-of-f1-drivers.png",
    "key": "the-precision-and-power-of-f1-drivers",
    "originalPath": "sports-and-recreation/the-precision-and-power-of-f1-drivers.png",
    "transformedName": "the-precision-and-power-of-f1-drivers.png",
    "transformedPath": "sports-and-recreation/the-precision-and-power-of-f1-drivers.png",
    "displayName": "The Precision And Power Of F1 Drivers",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/sports-and-recreation/the-precision-and-power-of-f1-drivers.png"
  }
,
  {
    "originalName": "the-road-to-regionals.png",
    "key": "the-road-to-regionals",
    "originalPath": "sports-and-recreation/the-road-to-regionals.png",
    "transformedName": "the-road-to-regionals.png",
    "transformedPath": "sports-and-recreation/the-road-to-regionals.png",
    "displayName": "The Road To Regionals",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/sports-and-recreation/the-road-to-regionals.png"
  }
,
  {
    "originalName": "the-softball-sisterhood.png",
    "key": "the-softball-sisterhood",
    "originalPath": "sports-and-recreation/the-softball-sisterhood.png",
    "transformedName": "the-softball-sisterhood.png",
    "transformedPath": "sports-and-recreation/the-softball-sisterhood.png",
    "displayName": "The Softball Sisterhood",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/sports-and-recreation/the-softball-sisterhood.png"
  }
,
  {
    "originalName": "under-the-stadium-lights.png",
    "key": "under-the-stadium-lights",
    "originalPath": "sports-and-recreation/under-the-stadium-lights.png",
    "transformedName": "under-the-stadium-lights.png",
    "transformedPath": "sports-and-recreation/under-the-stadium-lights.png",
    "displayName": "Under The Stadium Lights",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/sports-and-recreation/under-the-stadium-lights.png"
  }
,
  {
    "originalName": "cracking-the-code_-sat-edition.png",
    "key": "cracking-the-code_-sat-edition",
    "originalPath": "test-prep/cracking-the-code_-sat-edition.png",
    "transformedName": "cracking-the-code_-sat-edition.png",
    "transformedPath": "test-prep/cracking-the-code_-sat-edition.png",
    "displayName": "Cracking The Code_ Sat Edition",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/test-prep/cracking-the-code_-sat-edition.png"
  }
,
  {
    "originalName": "masterina-the-act.png",
    "key": "masterina-the-act",
    "originalPath": "test-prep/masterina-the-act.png",
    "transformedName": "masterina-the-act.png",
    "transformedPath": "test-prep/masterina-the-act.png",
    "displayName": "Masterina The Act",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/test-prep/masterina-the-act.png"
  }
,
  {
    "originalName": "preparing-for-elpac.png",
    "key": "preparing-for-elpac",
    "originalPath": "test-prep/preparing-for-elpac.png",
    "transformedName": "preparing-for-elpac.png",
    "transformedPath": "test-prep/preparing-for-elpac.png",
    "displayName": "Preparing For Elpac",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/test-prep/preparing-for-elpac.png"
  }
,
  {
    "originalName": "preparing-for-success_-ap-edition.png",
    "key": "preparing-for-success_-ap-edition",
    "originalPath": "test-prep/preparing-for-success_-ap-edition.png",
    "transformedName": "preparing-for-success_-ap-edition.png",
    "transformedPath": "test-prep/preparing-for-success_-ap-edition.png",
    "displayName": "Preparing For Success_ Ap Edition",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/test-prep/preparing-for-success_-ap-edition.png"
  }
,
  {
    "originalName": "unlocking-spac-vocabulary.png",
    "key": "unlocking-spac-vocabulary",
    "originalPath": "test-prep/unlocking-spac-vocabulary.png",
    "transformedName": "unlocking-spac-vocabulary.png",
    "transformedPath": "test-prep/unlocking-spac-vocabulary.png",
    "displayName": "Unlocking Spac Vocabulary",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/test-prep/unlocking-spac-vocabulary.png"
  }
,
  {
    "originalName": "around-the-world_-ireland.png",
    "key": "around-the-world_-ireland",
    "originalPath": "travel-and-exploration/around-the-world_-ireland.png",
    "transformedName": "around-the-world_-ireland.png",
    "transformedPath": "travel-and-exploration/around-the-world_-ireland.png",
    "displayName": "Around The World_ Ireland",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/travel-and-exploration/around-the-world_-ireland.png"
  }
,
  {
    "originalName": "climbing-the-peaks-of-patagonia.png",
    "key": "climbing-the-peaks-of-patagonia",
    "originalPath": "travel-and-exploration/climbing-the-peaks-of-patagonia.png",
    "transformedName": "climbing-the-peaks-of-patagonia.png",
    "transformedPath": "travel-and-exploration/climbing-the-peaks-of-patagonia.png",
    "displayName": "Climbing The Peaks Of Patagonia",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/travel-and-exploration/climbing-the-peaks-of-patagonia.png"
  }
,
  {
    "originalName": "footprints-through-the-fjords-(1).png",
    "key": "footprints-through-the-fjords-(1)",
    "originalPath": "travel-and-exploration/footprints-through-the-fjords-(1).png",
    "transformedName": "footprints-through-the-fjords-(1).png",
    "transformedPath": "travel-and-exploration/footprints-through-the-fjords-(1).png",
    "displayName": "Footprints Through The Fjords (1)",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/travel-and-exploration/footprints-through-the-fjords-(1).png"
  }
,
  {
    "originalName": "hidden-villages-of-the-himalayas.png",
    "key": "hidden-villages-of-the-himalayas",
    "originalPath": "travel-and-exploration/hidden-villages-of-the-himalayas.png",
    "transformedName": "hidden-villages-of-the-himalayas.png",
    "transformedPath": "travel-and-exploration/hidden-villages-of-the-himalayas.png",
    "displayName": "Hidden Villages Of The Himalayas",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/travel-and-exploration/hidden-villages-of-the-himalayas.png"
  }
,
  {
    "originalName": "lost-in-the-markets-of-marrakesh.png",
    "key": "lost-in-the-markets-of-marrakesh",
    "originalPath": "travel-and-exploration/lost-in-the-markets-of-marrakesh.png",
    "transformedName": "lost-in-the-markets-of-marrakesh.png",
    "transformedPath": "travel-and-exploration/lost-in-the-markets-of-marrakesh.png",
    "displayName": "Lost In The Markets Of Marrakesh",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/travel-and-exploration/lost-in-the-markets-of-marrakesh.png"
  }
,
  {
    "originalName": "mysteries-of-the-silk-road.png",
    "key": "mysteries-of-the-silk-road",
    "originalPath": "travel-and-exploration/mysteries-of-the-silk-road.png",
    "transformedName": "mysteries-of-the-silk-road.png",
    "transformedPath": "travel-and-exploration/mysteries-of-the-silk-road.png",
    "displayName": "Mysteries Of The Silk Road",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/travel-and-exploration/mysteries-of-the-silk-road.png"
  }
,
  {
    "originalName": "the-heartbeat-of-the-andes.png",
    "key": "the-heartbeat-of-the-andes",
    "originalPath": "travel-and-exploration/the-heartbeat-of-the-andes.png",
    "transformedName": "the-heartbeat-of-the-andes.png",
    "transformedPath": "travel-and-exploration/the-heartbeat-of-the-andes.png",
    "displayName": "The Heartbeat Of The Andes",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/travel-and-exploration/the-heartbeat-of-the-andes.png"
  }
,
  {
    "originalName": "the-road-less-travelled.png",
    "key": "the-road-less-travelled",
    "originalPath": "travel-and-exploration/the-road-less-travelled.png",
    "transformedName": "the-road-less-travelled.png",
    "transformedPath": "travel-and-exploration/the-road-less-travelled.png",
    "displayName": "The Road Less Travelled",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/travel-and-exploration/the-road-less-travelled.png"
  }
,
  {
    "originalName": "waves-and-wonders-of-the-australian-coast.png",
    "key": "waves-and-wonders-of-the-australian-coast",
    "originalPath": "travel-and-exploration/waves-and-wonders-of-the-australian-coast.png",
    "transformedName": "waves-and-wonders-of-the-australian-coast.png",
    "transformedPath": "travel-and-exploration/waves-and-wonders-of-the-australian-coast.png",
    "displayName": "Waves And Wonders Of The Australian Coast",
    "url": "https://static.readablenglish.com/re-v2/srp/platform/cover-thumbnails/travel-and-exploration/waves-and-wonders-of-the-australian-coast.png"
  }

]



const BasicInfoCard = ({ formData, onInputChange, recreatingCover, onRecreateCover }) => {
  const theme = useTheme();
  const [selectedThumbnail, setSelectedThumbnail] = useState(null);
  
  // Create a ref to store a flag indicating if we need to update the title
  const pendingTitleUpdate = useRef(null);
  
  // Check if we need to update the title after the component renders
  useEffect(() => {
    // If we have a pending title update, apply it
    if (pendingTitleUpdate.current && formData.thumbnailUrl === pendingTitleUpdate.current.url) {
      // The URL has been updated, now update the title
      onInputChange({
        target: {
          name: 'title',
          value: pendingTitleUpdate.current.title
        }
      });
      
      // Clear the pending update
      pendingTitleUpdate.current = null;
    }
  }, [formData.thumbnailUrl, onInputChange]);
  
  // Handle thumbnail selection
  const handleThumbnailSelect = (event, newValue) => {
    if (newValue) {
      // Set the selected thumbnail
      setSelectedThumbnail(newValue);
      
      // Store the pending title update keyed to the URL
      pendingTitleUpdate.current = {
        url: newValue.url,
        title: newValue.displayName
      };
      
      // First update the URL
      onInputChange({
        target: {
          name: 'thumbnailUrl',
          value: newValue.url
        }
      });
      
      // The title will be updated in the useEffect after the URL update is reflected in formData
    } else {
      setSelectedThumbnail(null);
    }
  };

  return (
    <Paper 
      sx={{ 
        mb: 4, 
        p: 3, 
        borderRadius: 1,
        backgroundColor: theme.palette.background.paper,
        border: '1px solid',
        borderColor: alpha(theme.palette.common.white, 0.1)
      }}
    >
      <Typography variant="h6" gutterBottom color="text.primary">
        Basic Information
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <TextField
            label="Title"
            name="title"
            value={formData.title || ''}
            onChange={(e) => onInputChange(e)}
            fullWidth
            required
            error={formData.title?.trim() === ''}
            helperText={formData.title?.trim() === '' ? 'Title is required' : ''}
            InputLabelProps={{ style: { color: theme.palette.text.secondary } }}
            InputProps={{ style: { color: theme.palette.text.primary } }}
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: alpha(theme.palette.common.white, 0.2),
                },
                '&:hover fieldset': {
                  borderColor: alpha(theme.palette.common.white, 0.3),
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.palette.primary.main,
                },
                backgroundColor: alpha(theme.palette.common.white, 0.05)
              }
            }}
          />
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            label="Synopsis"
            name="synopsis"
            value={formData.synopsis || ''}
            onChange={(e) => onInputChange(e)}
            fullWidth
            multiline
            rows={2}
            InputLabelProps={{ style: { color: theme.palette.text.secondary } }}
            InputProps={{ style: { color: theme.palette.text.primary } }}
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: alpha(theme.palette.common.white, 0.2),
                },
                '&:hover fieldset': {
                  borderColor: alpha(theme.palette.common.white, 0.3),
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.palette.primary.main,
                },
                backgroundColor: alpha(theme.palette.common.white, 0.05)
              }
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <Autocomplete
            options={thumbnailData}
            getOptionLabel={(option) => option.displayName}
            value={selectedThumbnail}
            onChange={handleThumbnailSelect}
            isOptionEqualToValue={(option, value) => option?.url === value?.url}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Thumbnail"
                fullWidth
                InputLabelProps={{ style: { color: theme.palette.text.secondary } }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: alpha(theme.palette.common.white, 0.2),
                    },
                    '&:hover fieldset': {
                      borderColor: alpha(theme.palette.common.white, 0.3),
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: theme.palette.primary.main,
                    },
                    backgroundColor: alpha(theme.palette.common.white, 0.05)
                  }
                }}
              />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            name="thumbnailUrl"
            label="Thumbnail URL"
            value={formData.thumbnailUrl || ''}
            onChange={(e) => onInputChange(e)}
            fullWidth
            margin="normal"
            InputLabelProps={{ style: { color: theme.palette.text.secondary } }}
            InputProps={{ style: { color: theme.palette.text.primary } }}
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: alpha(theme.palette.common.white, 0.2),
                },
                '&:hover fieldset': {
                  borderColor: alpha(theme.palette.common.white, 0.3),
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.palette.primary.main,
                },
                backgroundColor: alpha(theme.palette.common.white, 0.05)
              }
            }}
          />
        </Grid>
        
        {/* Current values display */}
        <Grid item xs={12}>
          <Typography variant="caption" color="text.secondary">
            Current title: {formData.title}
          </Typography>
          <br />
          <Typography variant="caption" color="text.secondary">
            Current URL: {formData.thumbnailUrl}
          </Typography>
          <br />
          {pendingTitleUpdate.current && (
            <Typography variant="caption" color="error">
              Pending title update to: {pendingTitleUpdate.current.title}
            </Typography>
          )}
        </Grid>
        
        {/* Cover Thumbnail Preview & Generation */}
        <Grid item xs={12}>
          <Box sx={{ mt: 2, p: 2, border: `1px dashed ${alpha(theme.palette.primary.main, 0.4)}`, borderRadius: 1, backgroundColor: alpha(theme.palette.primary.main, 0.02) }}>
            <Typography variant="subtitle2" gutterBottom color="text.primary" sx={{ fontWeight: 'bold' }}>
              Cover Thumbnail
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 3 }}>
              {formData.thumbnailUrl ? (
                <Box 
                  component="img" 
                  src={formData.thumbnailUrl} 
                  alt="Cover Thumbnail"
                  sx={{ 
                    maxWidth: '120px', 
                    maxHeight: '120px', 
                    borderRadius: 1, 
                    boxShadow: 3,
                    border: `1px solid ${alpha(theme.palette.common.white, 0.1)}`
                  }}
                />
              ) : (
                <Box 
                  sx={{ 
                    width: '120px', 
                    height: '120px', 
                    borderRadius: 1, 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    backgroundColor: alpha(theme.palette.common.white, 0.05),
                    border: `1px solid ${alpha(theme.palette.common.white, 0.1)}`
                  }}
                >
                  <Typography variant="caption" color="text.secondary">No Image</Typography>
                </Box>
              )}
              <Box sx={{ flex: 1, minWidth: '200px' }}>
                {formData.thumbnailUrl && (
                  <Typography variant="body2" color="text.secondary" sx={{ wordBreak: 'break-all', mb: 1 }}>
                    <strong>Current URL:</strong> {formData.thumbnailUrl}
                  </Typography>
                )}
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={recreatingCover ? <CircularProgress size={20} color="inherit" /> : <AutoAwesomeIcon />}
                  onClick={onRecreateCover}
                  disabled={recreatingCover}
                  sx={{
                    background: `linear-gradient(45deg, ${theme.palette.primary.main} 30%, ${theme.palette.secondary.main} 90%)`,
                    boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
                    fontWeight: 'bold',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'scale(1.02)',
                      boxShadow: '0 4px 10px 3px rgba(33, 203, 243, .5)',
                    }
                  }}
                >
                  {recreatingCover ? 'Generating Cover...' : 'Recreate Cover via AI'}
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default BasicInfoCard;